import Vue from 'vue'
import Router from 'vue-router'

import { clearLoginInfo } from '@/utils'
import { isURL } from '@/utils/validate'
import { menuApi,permissionApi} from "@/api/sys";
import { getToken, removeToken } from '@/utils/auth'
import store from '@/store'
import i18n from '../lang'
import Cookies from 'js-cookie'
import { LINUX_AUTO_MENU_IDS } from '@/constants/linuxAutoPortal'
import { SUPPORT_TICKET_MENU_IDS } from '@/constants/supportTicket'
import {
  canAccessSupportTicketCreate,
  canAccessSupportTicketMine,
  canAccessSupportTicketWorkbench
} from '@/utils/supportTicketPermissions'
import { dedupeRoutesByMenuIdPreferStatic } from '@/utils/sidebarRouteResolver'
import { isPlatformAdminFromStore } from '@/utils/platformAdmin'
import { stripUnassignedRbacSidebarMenus, pruneSidebarNodesByEnChecks, menuTreeContainsEnName, collectNavMenuIds, isNavAuthorizedMenuId } from '@/utils/sidebarPermissionFilter'
import { fillSidebarMenuIcons } from '@/utils/sidebarMenuIcons'
import {
  CHANNEL_CONFIG_CATALOG_ID,
  isChannelConfigExclusiveLeaf as isChannelConfigExclusiveMenuLeaf,
  isDeviceConfigExclusiveLeaf as isDeviceConfigExclusiveMenuLeaf,
  isMixedLegacyDeviceConfigRoot,
  partitionDeviceChannelLeaves
} from '@/utils/deviceChannelMenuSplit'
import { hasLeoPortalGate } from '@/utils/leoPortalGate'
// 开发环境不使用懒加载
const _import = require('./import-' + process.env.NODE_ENV)
const RouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return RouterPush.call(this, to).catch(err => err)
}
const originalReplace = Router.prototype.replace
Router.prototype.replace= function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}

Vue.use(Router)

function leoInternalRouteGuard (to, from, next) {
  if (hasLeoPortalGate(to.query)) {
    next()
    return
  }
  const query = { ...to.query }
  delete query.surface
  next({ name: 'leoStandaloneChat', query, replace: true })
}

// 全局路由(无需嵌套上左右整体布局)
const globalRoutes = [
  { path: '/404', component: _import('common/404/index'), name: '404', meta: { title: '' } },
  { path: '/login', component: _import('common/login/index'), name: 'login', meta: { title: '' } },
  { path: '/operation', component: _import('common/operation/index'), name: 'operation', meta: { title: '' } },
  { path: '/dataShow', component: _import('common/dataShow/index'), name: 'dataShow', meta: { title: '' } },
  { path: '/privacyAgreement', component: _import('common/login/privacy-agreement'), name: 'privacyAgreement', meta: { title: '' } },
  { path: '/privacyAgreement1', component: _import('common/login/privacy-agreement-1'), name: 'privacyAgreement1', meta: { title: '' } },
  { path: '/privacyAgreement2', component: _import('common/login/privacy-agreement-2'), name: 'privacyAgreement2', meta: { title: '' } },
  { path: '/membership/register', component: _import('membership/MembershipRegister'), name: 'membershipRegister', meta: { title: '會員註冊' } },
  { path: '/membership/login', component: _import('membership/MembershipLogin'), name: 'membershipLogin', meta: { title: '會員登入' } },
  { path: '/leo-portal', component: _import('leo/LeoBrainPortal'), name: 'leoPortal', meta: { title: 'Leo' }, beforeEnter: leoInternalRouteGuard },
  {
    path: '/leo',
    component: _import('leo/LeoHub'),
    redirect: '/leo/chat',
    children: [
      { path: 'chat', component: _import('leo/LeoStandaloneChat'), name: 'leoStandaloneChat', meta: { title: 'Leo' }, beforeEnter (to, from, next) {
        if (String(to.query.surface || '').trim().toLowerCase() === 'leosmart') {
          const query = { ...to.query }
          delete query.surface
          next({ path: to.path, query, hash: to.hash, replace: true })
          return
        }
        next()
      } },
      { path: 'billing', component: _import('leo/LeoBillingUsage'), name: 'leoBilling', meta: { title: 'Leo 用量與計費' } },
      { path: 'preferences', component: _import('leo/LeoMyPreferences'), name: 'leoMyPreferences', meta: { title: 'Leo 我的偏好' } },
      { path: 'console', component: _import('LeoBrainConsole'), name: 'leoConsole', meta: { title: 'Leo Console' }, beforeEnter: leoInternalRouteGuard },
      { path: 'login', component: _import('leo/LeoLogin'), name: 'leoLogin', meta: { title: 'Leo 登入' } },
      { path: 'membership-login', component: _import('membership/MembershipLogin'), name: 'leoMembershipLogin', meta: { title: '會員登入' } },
      { path: 'membership-register', component: _import('membership/MembershipRegister'), name: 'leoMembershipRegister', meta: { title: '會員註冊' } }
    ]
  },
  { path: '/leo-chat', redirect: '/leo/chat' },
  { path: '/leo-console', redirect: '/leo/chat' },
  { path: '/leo-login', redirect: '/leo/login' },
  {
    path: '/leo-device-integration',
    component: _import('common/leo-device-integration/LeoDeviceIntegrationPublic'),
    name: 'leoDeviceIntegrationPublic',
    meta: { title: 'Leo 裝置整合工具' }
  },
  {
    path: '/device-cloud-runtime',
    component: _import('common/device-cloud-runtime/DeviceCloudRuntimePublic'),
    name: 'deviceCloudRuntimePublic',
    meta: { title: 'XRROSS 裝置雲運行期模組' }
  },
  {
    path: '/xrross-sdk-engineer-lab',
    component: _import('common/sdk-engineer-lab/SdkEngineerLab'),
    name: 'xrrossSdkEngineerLab',
    meta: { title: 'XRROSS SDK 工程測試台' }
  },
  {
    path: '/support-ticket-h5',
    component: _import('support/ticket/h5/create'),
    name: 'support-ticket-h5',
    meta: {
      title: '手机提交工单',
      menuId: SUPPORT_TICKET_MENU_IDS.create,
      id: SUPPORT_TICKET_MENU_IDS.create,
      supportTicketPermission: 'support:ticket:create'
    }
  },
  {
    path: '/m/training-desk',
    component: _import('leoKnowledge/LeoTrainingDecisionDeskMobile'),
    name: 'leoTrainingDecisionDeskMobile',
    meta: { title: '训练决策台（手机）' }
  },

]

/** 與 appendStaticDeviceConfigRoutes、側欄項 id 一致；靜態 main 子路由須帶 meta.menuId 才能 gotoRouteHandle 命中。「模擬機」整組見 {@link hasSimulatorSidebarPermission}。 */
const DEVICE_CONFIG_MENU_IDS = {
  group: 990100,
  profileList: 990101,
  bindings: 990102,
  workbench: 990103,
  coffeeMachineChannels: 990123,
  x600hGateway: 990104,
  simulatorGroup: 990105,
  xt90c2Simulator: 990106,
  blenderSimulator: 990107,
  xosIviSimulator: 990108,
  hansonIviSimulator: 990122,
  deviceLinkDebug: 990124
}

/** X600H 工厂生产订单（静态侧栏 + 路由；coffee_menu id=990294，勿与 990125 冲突） */
const X600H_PRODUCTION_ORDER_MENU_IDS = {
  list: 990294
}

/** 设备生命周期（报废／僵尸；coffee_menu id=990328–990330） */
const EQUIPMENT_LIFECYCLE_MENU_IDS = {
  page: 990328
}

/** 设备列表（coffee_menu en_name=machineList, id=1721721668100947968） */
const MACHINE_LIST_MENU_IDS = {
  page: 1721721668100947968
}

/**
 * DB 歷史根節點（coffee_menu 常見 id）：曾混掛通道 + Profile；087 後僅 Profile 時不再剝離。
 */
const LEGACY_CHANNEL_CONFIG_API_ROOT_ID = 1721413909652439040

/** 通道配置側欄分組（對齊 coffee_menu 990295；勿用 990293） */
const CHANNEL_CONFIG_SIDEBAR_IDS = {
  group: Number(CHANNEL_CONFIG_CATALOG_ID)
}

/** 僅屬「設備配置」990100 的葉節點（勿出現在「通道配置」）— 邏輯見 deviceChannelMenuSplit.js */
const DEVICE_CONFIG_SIDEBAR_LEAF_EN = new Set([
  'configProfileLibrary',
  'configBindDispatch',
  'coffeeMachineChannelSlots'
])
const DEVICE_CONFIG_SIDEBAR_LEAF_IDS = new Set([
  DEVICE_CONFIG_MENU_IDS.profileList,
  DEVICE_CONFIG_MENU_IDS.bindings,
  DEVICE_CONFIG_MENU_IDS.workbench,
  DEVICE_CONFIG_MENU_IDS.coffeeMachineChannels,
  1900410300000000001,
  1900410300000000002
])

/** 僅屬「通道配置」的葉節點（勿重複在設備配置／出品管理） */
const CHANNEL_CONFIG_SIDEBAR_LEAF_EN = new Set([
  'configDistribute',
  'devicesChannels',
  'channelCategory'
])

/** 产品5 门店客制 POS（A→G）；与 mergeProduceFivePosMenu、静态 main 子路由 meta.menuId 一致 */
const POS_CENTER_MENU_IDS = {
  group: 990285,
  produceFivePos: 990286
}
const PRODUCE_FIVE_POS_MENU_ID = POS_CENTER_MENU_IDS.produceFivePos
/** 旧版注入 id（与 linuxAuto 990240 冲突），迁移时须从侧栏剔除 */
const PRODUCE_FIVE_POS_LEGACY_MENU_ID = 990240

/**
 * 數據中心 · X600H 咖啡機出品／單杯（與 coffee_menu 生產 id 對齊）。
 * 靜態路由用獨立 route name，避免 productionData／singleCupData 與其他機型 enName 衝突。
 */
const DATA_CENTER_COFFEE_MACHINE_MENU_IDS = {
  coffeeData: 1796036995663925248,
  productionData: 1796042739016667136,
  singleCupData: 1904791257176215552
}

/** 數據中心 · 配料機出品／單杯／故障（coffee_menu 東京生產 id） */
const DATA_CENTER_BLEND_MENU_IDS = {
  group: 1904793627641647104,
  productionData: 1904794259333189632,
  singleCupData: 1904794577232072704,
  faultLog: 1904794728583532544
}

/** 出品管理侧栏二级分组（虚拟文件夹；990287–990292 与 POS 990285+ 错开） */
const PRODUCT_CENTER_FOLDER_IDS = {
  basicDict: 990287,
  products: 990288,
  menuDispatch: 990289,
  channels: 990290,
  addons: 990291,
  other: 990292
}

const PRODUCT_CENTER_FOLDER_EN = new Set([
  'productCenterFolderBasic',
  'productCenterFolderProducts',
  'productCenterFolderMenu',
  'productCenterFolderChannels',
  'productCenterFolderAddons',
  'productCenterFolderOther'
])

const PRODUCT_CENTER_FOLDER_META = {
  basicDict: { name: '基礎字典', enName: 'productCenterFolderBasic' },
  products: { name: '品項與配方', enName: 'productCenterFolderProducts' },
  menuDispatch: { name: '菜單與下發', enName: 'productCenterFolderMenu' },
  channels: { name: '通道與綁定', enName: 'productCenterFolderChannels' },
  addons: { name: '配料與小吃', enName: 'productCenterFolderAddons' },
  other: { name: '其他產品', enName: 'productCenterFolderOther' } // 含稅務產品類型、其他稅務產品等
}

/** 叶子 enName → 分组 key（未命中进 other） */
const PRODUCT_CENTER_LEAF_BUCKET = {
  channelCategory: 'basicDict',
  productCategory: 'basicDict',
  optionCategory: 'basicDict',
  optionList: 'basicDict',
  /** 产品类型（税务计算维度）；展示名见 i18n route.type */
  type: 'other',
  productsList5: 'products',
  productsList2: 'products',
  produceList4: 'products',
  productionList: 'products',
  listOfTeaExtractsProducts: 'products',
  smoothieMakerProduct: 'products',
  /** 海外扩展产品列表（extra produce）；展示名见 i18n route.produce */
  produce: 'other',
  otherProducts: 'products',
  additionalProducts: 'products',
  takeoutProducts: 'products',
  storeMenu: 'menuDispatch',
  menuDistribute: 'menuDispatch',
  machineMenu: 'menuDispatch',
  devicesChannels: 'channels',
  configDistribute: 'channels',
  smallMaterial: 'addons',
  accessoriesCategory: 'addons',
  accessoriesList: 'addons'
}

const PRODUCT_CENTER_FOLDER_ORDER = ['basicDict', 'products', 'menuDispatch', 'channels', 'addons', 'other']

// 主入口路由(需嵌套上左右整体布局)
const mainRoutes = {
  path: '/',
  component: _import('layout/Layout'),
  name: 'main',
  redirect: { name: 'login' },
  meta: { title: '' },
  children: [
    // 通过meta对象设置路由展示方式
    // 1. isTab: 是否通过tab展示内容, true: 是, false: 否
    // 2. iframeUrl: 是否通过iframe嵌套展示内容, '以http[s]://开头': 是, '': 否
    // 提示: 如需要通过iframe嵌套展示内容, 但不通过tab打开, 请自行创建组件使用iframe处理!
    { path: '/home', component: _import('common/home/index'), name: 'home', meta: { title: i18n.t('route.homePage'), isTab: true } },
    { path: '/menu-nav', component: _import('common/menuNav/index'), name: 'menuNav', meta: { title: '選單導航', isTab: true } },
    { path: '/device-detail', component: _import('device/list/detail'), name: 'deviceDetail', meta: { title: i18n.t('route.details'), isTab: true } },
    { path: '/device-detailautomatic', component: _import('device/list/detailAutomatic'), name: 'automaticdeviceDetail', meta: { title: i18n.t('route.details'), isTab: true } },
     { path: '/device-coffee-params', component: _import('device/list/params/coffee/param'), name: 'coffeeMachineParam', meta: { title: i18n.t('route.details'), isTab: true } },
      { path: '/device-coffee-factory-params', component: _import('device/list/params/coffee/factoryParam'), name: 'coffeeMachineFactoryParam', meta: { title: i18n.t('route.details'), isTab: true } },
    { path: '/device-coffee-module-params', component: _import('device/list/params/coffee/moduleParam'), name: 'coffeeMachineModuleParam', meta: { title: i18n.t('route.details'), isTab: true } },  
    // { path: '/produce-params-detail', component: _import('produce/parameter/detail'), name: 'produceParamsDetail', meta: { title: '出品参数详情', isTab: true } },
    // { path: '/produce-name-detail', component: _import('produce/name/detail'), name: 'produceNameDetail', meta: { title: '出品名称详情', isTab: true } },
     { path: '/produce-name-create', component: _import('produce/nameTwo/create'), name: 'produceNameCreate', meta: { title: i18n.t('table.add'), isTab: true } },
     { path: '/produce-three-name-create', component: _import('produce/nameThree/create'), name: 'produceThreeNameCreate', meta: { title: i18n.t('table.add'), isTab: true } },
     { path: '/produce-blender-create', component: _import('produce/blender/create'), name: 'produceBlenderCreate', meta: { title: i18n.t('table.add'), isTab: true } },
     { path: '/produce-four-name-create', component: _import('produce/nameFour/create'), name: 'produceFourNameCreate', meta: { title: i18n.t('table.add'), isTab: true } },
     { path: '/produce-four-name-copy', component: _import('produce/nameFour/copy'), name: 'produceFourNameCopy', meta: { title: i18n.t('table.copy'), isTab: true } },
    { path: '/produce-name-addProduce', component: _import('produce/name/addProduce'), name: 'addProduce', meta: { title: i18n.t('table.add'), isTab: true } },
    { path: '/produce-name-editProduce', component: _import('produce/name/editProduce'), name: 'editProduce', meta: { title: i18n.t('table.edit'), isTab: true } },
    // { path: '/produce-import-detail', component: _import('produce/import/detail'), name: 'produceImportDetail', meta: { title: '出品导入详情', isTab: true } },
    { path: '/map', component: _import('common/map/index'), name: 'map', meta: { title: i18n.t('route.atlas') } },
    { path: '/merchant-machine', component: _import('merchant/machine/list'), name: 'merchantMachine', meta: { title: i18n.t('route.deviceList') } },
    {
      path: '/device-list-index',
      component: _import('device/list/index'),
      name: 'device-list-index',
      meta: {
        title: i18n.t('route.machineList'),
        isTab: true,
        isDynamic: false,
        menuId: MACHINE_LIST_MENU_IDS.page
      }
    },
    { path: '/device-journal', component: _import('device/list/journal'), name: 'machineJournal', meta: { title: i18n.t('route.journal'), isTab: true } },
    { path: '/device-x600h-production-order', component: _import('device/x600hProductionOrder/index'), name: 'x600hProductionOrder', meta: { title: 'X600H 生产订单', isTab: true, menuId: X600H_PRODUCTION_ORDER_MENU_IDS.list } },
    { path: '/device-x600h-production-order-detail', component: _import('device/x600hProductionOrder/detail'), name: 'x600hProductionOrderDetail', meta: { title: '生产订单详情', isTab: true } },
    { path: '/device-lifecycle', component: _import('device/lifecycle/index'), name: 'equipmentLifecycle', meta: { title: '设备生命周期', isTab: true, menuId: EQUIPMENT_LIFECYCLE_MENU_IDS.page } },
     { path: '/produce-store-product', component: _import('produce/store/product'), name: 'storeProduct', meta: { title: i18n.t('business.produce'), isTab: true } },
     { path: '/produce-machine-product', component: _import('produce/machine/product'), name: 'machineProduct', meta: { title: i18n.t('business.produce'), isTab: true } },
     { path: '/produce-machine-thermoplan-product', component: _import('produce/store/thermoplan/product'), name: 'storeThermoplanProduct', meta: { title: i18n.t('business.produce'), isTab: true } },
     { path: '/produce-thermoplan-machine-product', component: _import('produce/store/thermoplan/machineProduce'), name: 'storeThermoplanMachineProduct', meta: { title: i18n.t('business.produce'), isTab: true } },
    { path: '/dataCenter-machineDataStatistics', component: _import('dataCenter/machineDataStatistics/detail'), name: 'machineDetail', meta: { title: i18n.t('route.details'), isTab: true } },
    { path: '/system-device-link-debug', component: _import('systemSetting/deviceLinkDebug/index'), name: 'deviceLinkDebug', meta: { title: '设备通信调试', isTab: true, menuId: DEVICE_CONFIG_MENU_IDS.deviceLinkDebug } },
    { path: '/dataCenter-x600h-gateway', component: _import('dataCenter/x600hGateway/index'), name: 'x600hGatewayData', meta: { title: 'X600H', isTab: true, menuId: DEVICE_CONFIG_MENU_IDS.x600hGateway } },
    { path: '/simulator-xt90c2', component: _import('dataCenter/x600hGateway/index'), name: 'xt90c2Simulator', meta: { title: 'XT90C2 模擬機', isTab: true, menuId: DEVICE_CONFIG_MENU_IDS.xt90c2Simulator } },
    { path: '/simulator-blender', component: _import('simulator/blender/index'), name: 'blenderSimulator', meta: { title: 'Blender 模擬機', isTab: true, menuId: DEVICE_CONFIG_MENU_IDS.blenderSimulator } },
    { path: '/simulator-xos-ivi', component: _import('simulator/xosIvi/index'), name: 'xosIviSimulator', meta: { title: 'XOS 模擬機', isTab: true, menuId: DEVICE_CONFIG_MENU_IDS.xosIviSimulator } },
    { path: '/simulator-hanson-ivi', component: _import('simulator/hansonIvi/index'), name: 'hansonIviSimulator', meta: { title: 'Hansong IVI 模擬機', isTab: true, menuId: DEVICE_CONFIG_MENU_IDS.hansonIviSimulator } },
    { path: '/machine-bind-chargingBasket', component: _import('chargingBasketManagement/machineChargingBasket/chargingBasketList'), name: 'chargingBasketList', meta: { title: i18n.t('pass.pass'), isTab: true } },
    { path: '/single-product-detail', component: _import('dataCenter/teaDataStatistics/singleDetail'), name: 'singleDetail', meta: { title: i18n.t('route.details'), isTab: true } },
    { path: '/order-detail', component: _import('image/order/detail'), name: 'orderDetail', meta: { title: i18n.t('route.details'), isTab: true } },
    { path: '/produce-five-pos', redirect: '/image-order-produceFivePos' },
    {
      path: '/image-order-produceFivePos',
      component: _import('image/order/produceFivePos'),
      name: 'image-order-produceFivePos',
      meta: { title: i18n.t('route.produceFivePos'), isTab: true, menuId: PRODUCE_FIVE_POS_MENU_ID }
    },
    { path: '/produce-takeout-addProduce', component: _import('image/delivery/menu/addProduce'), name: 'addTakeoutProduce', meta: { title: i18n.t('table.add'), isTab: true } },
    { path: '/produce-takeout-editProduce', component: _import('image/delivery/menu/editProduce'), name: 'editTakeoutProduce', meta: { title: i18n.t('table.edit'), isTab: true } },
    { path: '/produce-delivery-store-product', component: _import('image/delivery/storeMenu/product'), name: 'uberStoreProduct', meta: { title: i18n.t('business.produce'), isTab: true } },
  
   
   
  ],
  beforeEnter (to, from, next) {
    let token = getToken()
    if (!token || !/\S/.test(token)) {
      clearLoginInfo()
      next({ name: 'login' })
      return
    }
    next()
  }
}

/** 動態選單註冊前快照：避免 fnAddDynamicMenuRoutes 用選單路由覆蓋後「進入平台」找不到 name: home */
const STATIC_MAIN_CHILDREN_SNAPSHOT = mainRoutes.children.slice()

/** axios / request 攔截器對任意 code!==200 皆 reject；僅 401 應導向登出，其餘錯誤須放行導航並勿清 token */
function isRouterAuthFailure (err) {
  if (!err) return false
  if (err.code === 401) return true
  if (err.response && err.response.status === 401) return true
  return false
}

const router =new Router({
   mode: 'hash',
   scrollBehavior: () => ({ y: 0 }),
   isAddDynamicMenuRoutes: false, // 是否已经添加动态(菜单)路由
   routes: globalRoutes.concat(mainRoutes)
})

/**
 * 以新路由表替換 matcher。僅 addRoute 疊加、且 removeRoute 未實作或未清空 nameMap 時，
 * 會對子路由名稱（如 home）重複註冊而觸發 Duplicate named routes。
 * 參考 vue-element-admin resetRouter：整表替換最穩。
 */
function replaceRouterMatcher (routes) {
  const opts = router.options
  const next = new Router({
    mode: opts.mode || 'hash',
    scrollBehavior: opts.scrollBehavior,
    isAddDynamicMenuRoutes: opts.isAddDynamicMenuRoutes,
    routes: routes
  })
  router.matcher = next.matcher
}

function readNavRawFromSession () {
  try {
    const raw = sessionStorage.getItem('menuApiRaw')
    const parsed = raw ? JSON.parse(raw) : []
    return Array.isArray(parsed) ? parsed : []
  } catch (e) {
    return []
  }
}

/** 路由守卫 SSOT：nav 已含该 enName 时不再用 session permissions 二次拦截 */
function navRawContainsEnName (enName) {
  if (!enName) return false
  return menuTreeContainsEnName(readNavRawFromSession(), enName)
}

router.beforeEach((to, from, next) => {
  if (to && (to.name === 'deviceLinkDebug' || to.name === 'x600hGatewayData' || to.name === 'xt90c2Simulator' || to.name === 'blenderSimulator' || to.name === 'xosIviSimulator' || to.name === 'hansonIviSimulator') && !hasSimulatorSidebarPermission()) {
    next({ name: 'home', replace: true })
    return
  }
  const routePathKey = String(to.path || '').replace(/^\//, '').replace(/\//g, '-')
  if (to && (
    (to.name && String(to.name).indexOf('memberHq') === 0) ||
    routePathKey.indexOf('member-hq-') === 0 ||
    routePathKey.indexOf('hq-member-') === 0
  ) && !navRawContainsEnName('memberHqGroup') && !navRawContainsEnName('memberHqDashboard') && !canAccessMemberHqGroupMenu()) {
    next({ name: 'home', replace: true })
    return
  }
  if (to && (
    (to.name && String(to.name).indexOf('distributor') === 0) ||
    routePathKey.indexOf('distributor-') === 0
  ) && !navRawContainsEnName('distributorReportGroup') && !navRawContainsEnName('distributorDashboard') && !canAccessDistributorReportMenu()) {
    next({ name: 'home', replace: true })
    return
  }
  if (to && (
    routePathKey.indexOf('linuxAuto-') === 0 ||
    routePathKey.indexOf('ivi-can-onboarding') === 0 ||
    to.name === 'leoInCarHub'
  ) && !navRawContainsEnName('linuxAutoOps') && !canAccessLinuxAutoOpsMenu()) {
    next({ name: 'home', replace: true })
    return
  }
  if (to && (
    to.name === 'x600hProductionOrder' ||
    to.name === 'x600hProductionOrderDetail' ||
    routePathKey.indexOf('device-x600h-production-order') === 0
  ) && !navRawContainsEnName('x600hProductionOrder') && !canAccessX600hProductionOrderMenu()) {
    next({ name: 'home', replace: true })
    return
  }
  if (to && (
    (to.name && String(to.name).indexOf('support-ticket') === 0) ||
    routePathKey.indexOf('support-ticket') === 0
  )) {
    const isCreate = to.name === 'support-ticket-create' || to.name === 'support-ticket-h5'
    const isMine = to.name === 'support-ticket-mine'
    const isWorkbench = to.name === 'support-ticket-workbench'
    if (isCreate && !navRawContainsEnName('supportTicketCreate') && !canAccessSupportTicketCreate()) {
      next({ name: 'home', replace: true })
      return
    }
    if (isMine && !navRawContainsEnName('supportTicketMine') && !canAccessSupportTicketMine()) {
      next({ name: 'home', replace: true })
      return
    }
    if (isWorkbench && !navRawContainsEnName('supportTicketWorkbench') && !canAccessSupportTicketWorkbench()) {
      next({ name: 'home', replace: true })
      return
    }
  }
  // 添加动态(菜单)路由
  // 1. 已经添加 or 全局路由, 直接访问
  // 2. 获取菜单列表, 添加并保存本地存储
  if (router.options.isAddDynamicMenuRoutes || fnCurrentRouteType(to, globalRoutes) === 'global') {
    const leoAny = to.meta && to.meta.leoKnowledgeAnyOf
    const leoReq = to.meta && to.meta.leoKnowledgePermission
    if (leoAny && Array.isArray(leoAny) && leoAny.length > 0) {
      const ok = leoAny.some((c) => hasPermission(c))
      if (!ok) {
        next({ name: 'home', replace: true })
        return
      }
    } else if (leoReq && !hasPermission(leoReq)) {
      next({ name: 'home', replace: true })
      return
    }
    next()
  } else {
    permissionApi()
      .catch((permErr) => {
        if (isRouterAuthFailure(permErr)) {
          return Promise.reject(permErr)
        }
        sessionStorage.setItem('permissions', '[]')
        return { code: 200, data: [] }
      })
      .then((permRes) => {
        if (permRes && permRes.code === 200) {
          sessionStorage.setItem('permissions', JSON.stringify(permRes.data || '[]'))
        } else {
          sessionStorage.setItem('permissions', '[]')
        }
        return menuApi()
      })
      .then((res) => {
        if (res && res.code === 200) {
          const rawMenus = res.data || []
          sessionStorage.setItem('menuApiRaw', JSON.stringify(rawMenus))
          const sidebarMenus = mergeDeviceConfigSidebarMenus(rawMenus)
          fnAddDynamicMenuRoutes(sidebarMenus)
          router.options.isAddDynamicMenuRoutes = true
          sessionStorage.setItem('menuList', JSON.stringify(sidebarMenus))
          store.commit('common/updateMenuList', sidebarMenus)
          next({ ...to, replace: true })
          return
        }
        sessionStorage.setItem('menuList', '[]')
        sessionStorage.setItem('permissions', '[]')
        if (to && to.name === 'home' && getToken() && /\S/.test(String(getToken()))) {
          applyEmptyDynamicMenuFallback()
        }
        next()
      })
      .catch((e) => {
        if (isRouterAuthFailure(e)) {
          store.dispatch('FedLogOut').then(() => {
            clearLoginInfo()
            removeToken()
            next({ name: 'login', replace: true })
          })
          return
        }
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.warn('[router] menu/permission 非 401 錯誤，中止本次導航並保留登入狀態：', e && e.message ? e.message : e)
        }
        sessionStorage.setItem('permissions', '[]')
        // 登入後先到 /dataShow 再進入 home 時，menu/permission 常易失敗；不應靜默 next(false) 致「进入平台」無反應
        if (to && to.name === 'home' && getToken() && /\S/.test(String(getToken()))) {
          applyEmptyDynamicMenuFallback()
          next({ name: 'home', replace: true })
        } else {
          next(false)
        }
      })
  }
})

/**
 * 判断当前路由类型, global: 全局路由, main: 主入口路由
 * @param {*} route 当前路由
 */
function fnCurrentRouteType (route, globalRoutes = []) {
  if (route.path === '/leo' || route.path.startsWith('/leo/')) {
    return 'global'
  }
  var temp = []
  for (var i = 0; i < globalRoutes.length; i++) {
    if (route.path === globalRoutes[i].path) {
      return 'global'
    } else if (globalRoutes[i].children && globalRoutes[i].children.length >= 1) {
      temp = temp.concat(globalRoutes[i].children)
    }
  }
  return temp.length >= 1 ? fnCurrentRouteType(route, temp) : 'main'
}

/** Leo 知識庫／智慧型號骨架側欄（與 SPEC：型號欄位、上傳、Onboarding） */
/** 與 coffee_menu patch 035 對齊：990211／990212 保留為 RBAC 葉節點（view／upload），頁面節點自 990241 起，避免與 013／016／017 等既有 id 衝突。 */
const LEO_KNOWLEDGE_MENU_IDS = {
  group: 990200,
  modelFields: 990241,
  upload: 990242,
  onboarding: 990243,
  capabilityMatrix: 990244,
  pipelineHub: 990245,
  featureSurface: 990246,
  protocolDoc: 990247,
  remoteTool: 990248,
  learning: 990249,
  externalIngest: 990250,
  ingestBatch: 990251,
  phase1Ssot: 990252,
  equipmentTypeTypeKey: 990253,
  testerConsole: 990254,
  deviceOpsRolePolicy: 990255,
  deviceOpsSemanticTraining: 990256,
  productionE2eTraining: 990266,
  turnRoutingTraining: 990267,
  trainingDashboard: 990268,
  t2GoldenTraining: 990269,
  t9DeepseekTraining: 990270,
  portalHub: 990257,
  portalOpsInventoryConsole: 990258,
  portalOpsDailyHub: 990259,
  deviceOpsReviewInbox: 990260,
  deviceOpsDescriptionAutogen: 990261,
  deviceOpsBLineDailyHub: 990262,
  uiSurfaceSample: 990263,
  aiTrusteeAdmin: 990271,
  agentPermissionSteward: 990272,
  platformReleaseControl: 990340,
  equipmentModelRepair: 990326,
  commandOnboardingWizard: 990264,
  xeeGrowthDashboard: 990265,
  trainingFederationCases: 991001,
  trainingFederationCommandCenter: 991002,
  tasteHabitPerception: 991003,
  trainingDecisionDesk: 991004,
  t7TasteMl: 991005,
  clawPlanCapabilityHub: 991006
}

function isTrainingLakeHost () {
  return String(process.env.VUE_APP_TRAINING_LAKE_HOST || '').toLowerCase() === 'true'
}

/** Leo 侧栏二级分组（虚拟文件夹，无 url／路由；990276–990279、990284 与会员 HQ／POS 错开） */
const LEO_SIDEBAR_FOLDER_IDS = {
  portalOverview: 990276,
  modelKnowledge: 990277,
  ingestLoop: 990278,
  protocolTools: 990279,
  opsWorkbench: 990284
}

const LEO_OPS_MENU_IDS_IN_SYSTEM_SETTINGS = new Set([
  LEO_KNOWLEDGE_MENU_IDS.deviceOpsBLineDailyHub,
  LEO_KNOWLEDGE_MENU_IDS.xeeGrowthDashboard,
  LEO_KNOWLEDGE_MENU_IDS.deviceOpsRolePolicy,
  LEO_KNOWLEDGE_MENU_IDS.deviceOpsSemanticTraining,
  LEO_KNOWLEDGE_MENU_IDS.productionE2eTraining,
  LEO_KNOWLEDGE_MENU_IDS.trainingDashboard,
  LEO_KNOWLEDGE_MENU_IDS.t2GoldenTraining,
  LEO_KNOWLEDGE_MENU_IDS.t9DeepseekTraining,
  LEO_KNOWLEDGE_MENU_IDS.tasteHabitPerception,
  LEO_KNOWLEDGE_MENU_IDS.turnRoutingTraining,
  LEO_KNOWLEDGE_MENU_IDS.portalOpsDailyHub,
  LEO_KNOWLEDGE_MENU_IDS.portalOpsInventoryConsole,
  LEO_KNOWLEDGE_MENU_IDS.deviceOpsReviewInbox,
  LEO_KNOWLEDGE_MENU_IDS.deviceOpsDescriptionAutogen,
  LEO_KNOWLEDGE_MENU_IDS.commandOnboardingWizard
])

const LEO_OPS_STRIP_EN_FROM_SYSTEM = new Set([
  'leoDeviceOpsBLineDailyHub',
  'leoXeeGrowthDashboard',
  'leoDeviceOpsRolePolicy',
  'leoDeviceOpsSemanticTraining',
  'leoProductionE2eTraining',
  'leoTrainingDashboard',
  'leoT2GoldenTraining',
  'leoT9DeepseekTraining',
  'leoTurnRoutingTrainingHub',
  'leoKnowledgePortalOpsDailyHub',
  'leoKnowledgePortalOpsInventory',
  'leoDeviceOpsReviewInbox',
  'leoDeviceOpsDescriptionAutogen',
  'leoCommandOnboardingWizard',
  'leoTasteHabitPerception'
])

/** 側欄靜態合併會重建 Leo 樹；自 API 樹剔除以免與 coffee_menu（patch 035）重複。 */
const LEO_SIDEBAR_STRIP_IDS = new Set(Object.values(LEO_KNOWLEDGE_MENU_IDS))
const LEO_SIDEBAR_STRIP_EN = new Set([
  'leoKnowledgeGroup',
  'leoKnowledgePortalHub',
  'leoKnowledgeUiSurfaceSample',
  'leoKnowledgeModelFields',
  'leoKnowledgeEquipmentTypeTypeKey',
  'leoKnowledgeUpload',
  'leoKnowledgeIngestBatch',
  'leoKnowledgePhase1Ssot',
  'leoKnowledgeCapabilityMatrix',
  'leoKnowledgeOnboarding',
  'leoKnowledgeTesterConsole',
  'leoKnowledgePipelineHub',
  'leoKnowledgeFeatureSurface',
  'leoKnowledgeProtocolDoc',
  'leoKnowledgeRemoteTools',
  'leoKnowledgeLearning',
  'leoKnowledgeExternalIngest',
  'leoDeviceOpsRolePolicy',
  'leoDeviceOpsSemanticTraining',
  'leoProductionE2eTraining',
  'leoTrainingDashboard',
  'leoT2GoldenTraining',
  'leoT9DeepseekTraining',
  'leoTurnRoutingTrainingHub',
  'leoKnowledgePortalOpsInventory',
  'leoKnowledgePortalOpsDailyHub',
  'leoDeviceOpsReviewInbox',
  'leoDeviceOpsDescriptionAutogen',
  'leoDeviceOpsBLineDailyHub',
  'leoCommandOnboardingWizard',
  'leoXeeGrowthDashboard',
  'leoTasteHabitPerception'
])

function findMenuNodeById (nodes, id) {
  if (!Array.isArray(nodes) || id == null) return null
  const want = Number(id)
  for (let i = 0; i < nodes.length; i++) {
    const n = nodes[i]
    if (!n) continue
    if (Number(n.id) === want) return n
    const hit = findMenuNodeById(n.menuList, id)
    if (hit) return hit
  }
  return null
}

function menuTreeContainsNodeId (nodes, id) {
  return !!findMenuNodeById(nodes, id)
}

/** 會員 HQ × 分銷商報表（與 patch 080/082 coffee_menu 對齊；勿與 LEO 990271/272 混用） */
const MEMBER_HQ_MENU_IDS = {
  group: 990285,
  dashboard: 990273,
  list: 990273,
  detail: 990305,
  finance: 990274,
  ops: 990275,
  distGroup: 990280,
  distDashboard: 990281,
  distMembers: 990282,
  distProfit: 990283
}

/** 商家 Token 帳單平台（與 DB patch 029、views/accountManagement/tokenBillingPlatform 對齊） */
const MERCHANT_TOKEN_BILLING_PLATFORM_MENU_ID = 990231
const MERCHANT_DATA_BILLING_PLATFORM_MENU_ID = 990232

function findProductCenterSidebarParent (nodes) {
  if (!Array.isArray(nodes)) return null
  for (let i = 0; i < nodes.length; i++) {
    const n = nodes[i]
    if (!n) continue
    const name = String(n.name || '')
    const en = String(n.enName || '').trim()
    if (name === '出品管理' || en === 'productCenter') return n
    if (Array.isArray(n.menuList) && n.menuList.length) {
      const hit = findProductCenterSidebarParent(n.menuList)
      if (hit) return hit
    }
  }
  return null
}

function findBusinessCenterSidebarParent (nodes) {
  if (!Array.isArray(nodes)) return null
  for (let i = 0; i < nodes.length; i++) {
    const n = nodes[i]
    if (!n) continue
    const name = String(n.name || '')
    const en = String(n.enName || '').trim()
    if (name === '业务中心' || name === '業務中心' || en === 'businessCenter') return n
    if (Array.isArray(n.menuList) && n.menuList.length) {
      const hit = findBusinessCenterSidebarParent(n.menuList)
      if (hit) return hit
    }
  }
  return null
}

function stripProduceFivePosLegacyPlacements (nodes) {
  if (!Array.isArray(nodes)) return
  for (let i = nodes.length - 1; i >= 0; i--) {
    const n = nodes[i]
    if (!n) {
      nodes.splice(i, 1)
      continue
    }
    const isLegacyLeaf = (Number(n.id) === PRODUCE_FIVE_POS_LEGACY_MENU_ID ||
      (n.enName === 'produceFivePos' && Number(n.id) !== PRODUCE_FIVE_POS_MENU_ID))
    const isPosGroup = Number(n.id) === POS_CENTER_MENU_IDS.group
    if (isLegacyLeaf && !isPosGroup) {
      nodes.splice(i, 1)
      continue
    }
    if (Array.isArray(n.menuList) && n.menuList.length) {
      stripProduceFivePosLegacyPlacements(n.menuList)
    }
  }
  const productCenter = findProductCenterSidebarParent(nodes)
  if (productCenter && Array.isArray(productCenter.menuList)) {
    productCenter.menuList = productCenter.menuList.filter((x) => {
      if (!x) return false
      if (x.enName === 'produceFivePos') return false
      if (Number(x.id) === PRODUCE_FIVE_POS_LEGACY_MENU_ID) return false
      if (Number(x.id) === PRODUCE_FIVE_POS_MENU_ID) return false
      return true
    })
  }
}

function upsertDataCenterCoffeeMachineLeaf (menuList, leaf) {
  if (!Array.isArray(menuList) || !leaf) return
  const idx = menuList.findIndex(
    (x) =>
      x &&
      (Number(x.id) === Number(leaf.id) ||
        (leaf.enName && menuNodeEnName(x) === leaf.enName))
  )
  if (idx >= 0) {
    menuList[idx] = Object.assign({}, menuList[idx], leaf)
  } else {
    menuList.push(leaf)
  }
}

/** 後端 nav 已授權「咖啡机数据」分支時才合併（萃茶机等其它机型也复用 singleCupData/productionData enName，不可仅凭 enName 触发） */
function apiMenuTreeContainsDataCenterCoffeeMachineMerge (raw) {
  if (!Array.isArray(raw) || !raw.length) return false
  const ids = DATA_CENTER_COFFEE_MACHINE_MENU_IDS
  if (menuTreeContainsEnName(raw, 'coffeeData')) return true
  return (
    menuTreeContainsNodeId(raw, ids.coffeeData) ||
    menuTreeContainsNodeId(raw, ids.productionData) ||
    menuTreeContainsNodeId(raw, ids.singleCupData)
  )
}

/** X600H 咖啡機：數據中心下「出品數據」「單杯數據」側欄（頁面已實作於 machineDataStatistics） */
function mergeDataCenterCoffeeMachineMenus (list, rawApiMenus) {
  if (!apiMenuTreeContainsDataCenterCoffeeMachineMerge(rawApiMenus)) return
  const dc = findDataCenterSidebarParent(list)
  if (!dc) return
  if (!Array.isArray(dc.menuList)) dc.menuList = []

  const productionLeaf = {
    id: DATA_CENTER_COFFEE_MACHINE_MENU_IDS.productionData,
    name: '出品数据',
    enName: 'productionData',
    url: 'dataCenter/machineDataStatistics/productStatistics',
    icon: 'list'
  }
  const singleCupLeaf = {
    id: DATA_CENTER_COFFEE_MACHINE_MENU_IDS.singleCupData,
    name: '单杯数据',
    enName: 'singleCupData',
    url: 'dataCenter/machineDataStatistics/singleProductStatistics',
    icon: 'maintain'
  }

  const groupId = DATA_CENTER_COFFEE_MACHINE_MENU_IDS.coffeeData
  let group = dc.menuList.find(
    (x) => x && (Number(x.id) === groupId || menuNodeEnName(x) === 'coffeeData')
  )
  if (!group) {
    dc.menuList.push({
      id: groupId,
      name: '咖啡机数据',
      enName: 'coffeeData',
      icon: 'paper-cup',
      menuList: [productionLeaf, singleCupLeaf]
    })
    return
  }
  if (!Array.isArray(group.menuList)) group.menuList = []
  upsertDataCenterCoffeeMachineLeaf(group.menuList, productionLeaf)
  upsertDataCenterCoffeeMachineLeaf(group.menuList, singleCupLeaf)
}

function mergeProduceFivePosMenu (list) {
  // 不在此處校驗 produce:*：merge 早於 permissionApi，首登 session 尚無 *:*:* 會誤判。
  stripProduceFivePosLegacyPlacements(list)
  const business = findBusinessCenterSidebarParent(list)
  if (!business || !Array.isArray(business.menuList)) return
  const leaf = {
    id: PRODUCE_FIVE_POS_MENU_ID,
    name: '产品5门店客制',
    enName: 'produceFivePos',
    url: 'image/order/produceFivePos',
    icon: 'shopping'
  }
  let group = business.menuList.find((x) => x && Number(x.id) === POS_CENTER_MENU_IDS.group)
  if (!group) {
    business.menuList.push({
      id: POS_CENTER_MENU_IDS.group,
      name: 'POS中心',
      enName: 'posCenter',
      icon: 'shopping',
      menuList: [leaf]
    })
    return
  }
  if (!Array.isArray(group.menuList)) group.menuList = []
  const idx = group.menuList.findIndex((x) => x && (Number(x.id) === PRODUCE_FIVE_POS_MENU_ID || x.enName === 'produceFivePos'))
  if (idx >= 0) group.menuList[idx] = leaf
  else group.menuList.push(leaf)
}

function flattenProductCenterMenuItems (items) {
  const out = []
  if (!Array.isArray(items)) return out
  for (let i = 0; i < items.length; i++) {
    const n = items[i]
    if (!n) continue
    const en = n.enName != null ? String(n.enName).trim() : ''
    const children = Array.isArray(n.menuList) ? n.menuList : []
    const hasUrl = n.url != null && /\S/.test(String(n.url))
    if (children.length && (PRODUCT_CENTER_FOLDER_EN.has(en) || !hasUrl)) {
      const nested = flattenProductCenterMenuItems(children)
      for (let j = 0; j < nested.length; j++) out.push(nested[j])
    } else {
      out.push(n)
    }
  }
  return out
}

function buildProductCenterSidebarTree (leaves) {
  const buckets = {
    basicDict: [],
    products: [],
    menuDispatch: [],
    channels: [],
    addons: [],
    other: []
  }
  for (let i = 0; i < leaves.length; i++) {
    const leaf = leaves[i]
    if (!leaf) continue
    const en = leaf.enName != null ? String(leaf.enName).trim() : ''
    if (en === 'produceFivePos') continue
    const key = PRODUCT_CENTER_LEAF_BUCKET[en] || 'other'
    buckets[key].push(leaf)
  }
  const groups = []
  for (let f = 0; f < PRODUCT_CENTER_FOLDER_ORDER.length; f++) {
    const key = PRODUCT_CENTER_FOLDER_ORDER[f]
    const items = buckets[key]
    if (!items || !items.length) continue
    const meta = PRODUCT_CENTER_FOLDER_META[key]
    const folder = leoSidebarFolder(
      PRODUCT_CENTER_FOLDER_IDS[key],
      meta.name,
      meta.enName,
      items
    )
    if (folder) groups.push(folder)
  }
  return groups
}

/** 出品管理：API 平铺叶子 → 五组二级树（不改叶子 menuId／url） */
function mergeProductCenterSidebarTree (list) {
  const productCenter = findProductCenterSidebarParent(list)
  if (!productCenter || !Array.isArray(productCenter.menuList)) return
  const leaves = flattenProductCenterMenuItems(productCenter.menuList)
  if (!leaves.length) return
  const grouped = buildProductCenterSidebarTree(leaves)
  if (!grouped.length) return
  productCenter.menuList = grouped
}

function findAccountSettingsSidebarParent (nodes) {
  if (!Array.isArray(nodes)) return null
  for (let i = 0; i < nodes.length; i++) {
    const n = nodes[i]
    if (!n) continue
    const name = String(n.name || '')
    const en = String(n.enName || '').trim()
    if (name === '账号设置' || name === '帳號設置' || name === '帐号设置') return n
    if (en === 'accountSetting' || en === 'accountSettings') return n
    if (Array.isArray(n.menuList) && n.menuList.length) {
      const hit = findAccountSettingsSidebarParent(n.menuList)
      if (hit) return hit
    }
  }
  return null
}

function findLoginAccountSidebarParent (nodes) {
  if (!Array.isArray(nodes)) return null
  for (let i = 0; i < nodes.length; i++) {
    const n = nodes[i]
    if (!n) continue
    const en = String(n.enName || '').trim()
    if (en === 'loginAccount') return n
    if (Array.isArray(n.menuList) && n.menuList.length) {
      const hit = findLoginAccountSidebarParent(n.menuList)
      if (hit) return hit
    }
  }
  return null
}

function hasAnyPermission (codes) {
  if (!Array.isArray(codes) || !codes.length) return false
  return codes.some((c) => hasPermission(c))
}

/** 與 coffee_menu perms（patch 079）對齊 */
function canAccessMemberHqGroupMenu () {
  return hasPermission('hq:member:view')
}

/** 與 coffee_menu perms（patch 079）對齊 */
function canAccessDistributorReportMenu () {
  return hasPermission('distributor:report:read')
}

/** 與 registerLeoInCarStaffRoutes 對齊（leo:knowledge:view|upload） */
function canAccessLinuxAutoOpsMenu () {
  return hasAnyPermission([LEO_KNOWLEDGE_PERM_CODES.VIEW, LEO_KNOWLEDGE_PERM_CODES.UPLOAD])
}

/** 與 coffee_menu 990231 / patch 079 對齊 */
function canAccessMerchantTokenBillingMenu () {
  return hasPermission('merchant:token:billing:view')
}

/** 與 coffee_menu 990232 / patch 079 對齊 */
function canAccessMerchantDataBillingMenu () {
  return hasPermission('merchant:data:billing:view')
}

/** 与 coffee_menu 990294 / SaToken x600h:production-order:* 对齐；勿用 device:add 泛化 */
function canAccessX600hProductionOrderMenu () {
  return hasPermission('x600h:production-order:view') ||
    hasPermission('x600h:production-order:edit')
}

/** 設備配置靜態合併：僅當 menuApi 已含 deviceConfig 綁定時保留 */
function apiMenuTreeContainsDeviceConfigRoot (raw) {
  if (!Array.isArray(raw) || !raw.length) return false
  if (menuTreeContainsNodeId(raw, DEVICE_CONFIG_MENU_IDS.group)) return true
  if (menuTreeContainsEnName(raw, 'deviceConfig')) return true
  function walk (list) {
    for (let i = 0; i < list.length; i++) {
      const n = list[i]
      if (!n) continue
      if (isLegacyApiDeviceConfigRoot(n)) return true
      if (Array.isArray(n.menuList) && n.menuList.length && walk(n.menuList)) return true
    }
    return false
  }
  return walk(raw)
}

/** 模擬機靜態合併：僅當 nav 已含模擬器相關綁定 */
function apiMenuTreeContainsSimulatorMerge (raw) {
  if (!Array.isArray(raw) || !raw.length) return false
  if (menuTreeContainsNodeId(raw, DEVICE_CONFIG_MENU_IDS.simulatorGroup)) return true
  const ens = ['simulatorGroup', 'x600hGateway', 'xt90c2Simulator', 'blenderSimulator', 'deviceSimulatorConsole']
  for (let i = 0; i < ens.length; i++) {
    if (menuTreeContainsEnName(raw, ens[i])) return true
  }
  return false
}

function pruneUnauthorizedDeviceConfigSidebar (nodes, rawApiMenus) {
  if (!Array.isArray(nodes)) return
  if (apiMenuTreeContainsDeviceConfigRoot(rawApiMenus)) return
  for (let i = nodes.length - 1; i >= 0; i--) {
    const n = nodes[i]
    if (!n) continue
    const id = Number(n.id)
    const en = menuNodeEnName(n)
    if (id === DEVICE_CONFIG_MENU_IDS.group || en === 'deviceConfig') {
      nodes.splice(i, 1)
      continue
    }
    if (Array.isArray(n.menuList) && n.menuList.length) {
      pruneUnauthorizedDeviceConfigSidebar(n.menuList, rawApiMenus)
    }
  }
}

function pruneUnauthorizedInjectedSidebarMenus (nodes, navAuthorizedIds) {
  if (!Array.isArray(nodes)) return
  for (let i = nodes.length - 1; i >= 0; i--) {
    const n = nodes[i]
    if (!n) {
      nodes.splice(i, 1)
      continue
    }
    if (isNavAuthorizedMenuId(n.id, navAuthorizedIds)) {
      if (Array.isArray(n.menuList) && n.menuList.length) {
        pruneUnauthorizedInjectedSidebarMenus(n.menuList, navAuthorizedIds)
      }
      continue
    }
    const id = Number(n.id)
    const en = n.enName != null ? String(n.enName).trim() : ''
    if (id === MEMBER_HQ_MENU_IDS.group && !canAccessMemberHqGroupMenu()) {
      nodes.splice(i, 1)
      continue
    }
    if (id === MEMBER_HQ_MENU_IDS.distGroup && !canAccessDistributorReportMenu()) {
      nodes.splice(i, 1)
      continue
    }
    if (id === LINUX_AUTO_MENU_IDS.group && !canAccessLinuxAutoOpsMenu()) {
      nodes.splice(i, 1)
      continue
    }
    if ((id === X600H_PRODUCTION_ORDER_MENU_IDS.list || en === 'x600hProductionOrder') &&
      !canAccessX600hProductionOrderMenu()) {
      nodes.splice(i, 1)
      continue
    }
    const coffeeDcIds = DATA_CENTER_COFFEE_MACHINE_MENU_IDS
    if (
      (id === coffeeDcIds.coffeeData || id === coffeeDcIds.productionData || id === coffeeDcIds.singleCupData ||
        en === 'coffeeData') &&
      !isNavAuthorizedMenuId(id, navAuthorizedIds)
    ) {
      nodes.splice(i, 1)
      continue
    }
    if (Array.isArray(n.menuList) && n.menuList.length) {
      pruneUnauthorizedInjectedSidebarMenus(n.menuList, navAuthorizedIds)
      if (!n.menuList.length && !/\S/.test(String(n.url || ''))) {
        nodes.splice(i, 1)
      }
    }
  }
}

function buildSidebarRbacEnChecks () {
  return {
    memberHqGroup: () => canAccessMemberHqGroupMenu(),
    memberHqDashboard: () => canAccessMemberHqGroupMenu(),
    memberHqFinance: () => canAccessMemberHqGroupMenu(),
    memberHqOps: () => canAccessMemberHqGroupMenu(),
    distributorReportGroup: () => canAccessDistributorReportMenu(),
    distributorDashboard: () => canAccessDistributorReportMenu(),
    distributorMembers: () => canAccessDistributorReportMenu(),
    distributorProfit: () => canAccessDistributorReportMenu(),
    linuxAutoOps: () => canAccessLinuxAutoOpsMenu(),
    linuxAutoEquipment: () => canAccessLinuxAutoOpsMenu(),
    linuxAutoRemoteOps: () => canAccessLinuxAutoOpsMenu(),
    linuxAutoProfileConfig: () => canAccessLinuxAutoOpsMenu(),
    linuxAutoDataBilling: () => canAccessLinuxAutoOpsMenu(),
    linuxAutoModelRegistry: () => canAccessLinuxAutoOpsMenu(),
    linuxAutoPartnerDelivery: () => canAccessLinuxAutoOpsMenu(),
    linuxAutoFleetMonitor: () => canAccessLinuxAutoOpsMenu(),
    linuxAutoDbcEntitlement: () => canAccessLinuxAutoOpsMenu(),
    linuxAutoCabinFeatures: () => canAccessLinuxAutoOpsMenu(),
    linuxAutoCanAutoMatch: () => canAccessLinuxAutoOpsMenu(),
    x600hProductionOrder: () => canAccessX600hProductionOrderMenu()
  }
}

function applySidebarRbacFilter (list, rawApiMenus) {
  const navIds = collectNavMenuIds(rawApiMenus)
  stripUnassignedRbacSidebarMenus(list, rawApiMenus)
  pruneSidebarNodesByEnChecks(list, buildSidebarRbacEnChecks(), navIds)
  pruneUnauthorizedDeviceConfigSidebar(list, rawApiMenus)
  pruneUnauthorizedInjectedSidebarMenus(list, navIds)
}

/** 會員 HQ／渠道：僅依後端 nav + 角色授權，禁止前端硬注入（见 sidebarPermissionFilter） */
function mergeMemberHqMenu (_list) {
  /* no-op */
}

function mergeMerchantTokenBillingPlatformMenu (_list) {
  /* no-op — 990231 由 coffee_menu + role_menu 控制 */
}

function mergeMerchantDataBillingPlatformMenu (_list) {
  /* no-op — 990232 由 coffee_menu + role_menu 控制 */
}

/** 車載運營：僅依後端 nav + leo:knowledge 權限，禁止前端硬注入 */
function mergeLinuxAutoOpsMenu (_list) {
  /* no-op */
}

/** 與後台 Sa-Token（Leo／product onboarding）一致，供 meta.leoKnowledgePermission 與側欄過濾 */
const LEO_KNOWLEDGE_PERM_CODES = {
  VIEW: 'leo:knowledge:view',
  UPLOAD: 'leo:knowledge:upload'
}

function getPermissionsFromSession () {
  try {
    const raw = sessionStorage.getItem('permissions')
    const parsed = raw ? JSON.parse(raw) : []
    return Array.isArray(parsed) ? parsed : []
  } catch (e) {
    return []
  }
}

function hasPermission (code) {
  if (!code) return true
  const perms = getPermissionsFromSession()
  return perms.includes(code) || perms.includes('*:*:*')
}

/** Leo 侧栏：API nav 已含 leoKnowledgeGroup 或平台 admin 时须重建树（strip 后不能仅靠 session permissions）。 */
function resolveLeoKnowledgeSidebarGates (rawApiMenus) {
  const raw = Array.isArray(rawApiMenus) ? rawApiMenus : []
  const navHasLeoKnowledge = menuTreeContainsEnName(raw, 'leoKnowledgeGroup')
  const isPlatformAdmin = isPlatformAdminFromStore(store)
  const leoView = hasPermission(LEO_KNOWLEDGE_PERM_CODES.VIEW) || navHasLeoKnowledge || isPlatformAdmin
  const leoUpload = hasPermission(LEO_KNOWLEDGE_PERM_CODES.UPLOAD) || isPlatformAdmin
  return { leoView, leoUpload }
}

/** 側欄「模擬機」整組（X600H + XT90C2）；優先 granting {@code device:simulator:view}（DB 見 patch 020）。仍接受舊碼 {@code x600h:gateway:view}。 */
function hasSimulatorSidebarPermission () {
  return hasPermission('device:simulator:view') || hasPermission('x600h:gateway:view')
}

function hasAdministratorSidebarPermission () {
  return hasPermission('administrator:add') || hasPermission('administrator:edit')
}

/**
 * menuApi 會帶入 coffee_menu 中的模擬器樹（patch 020：990105／990104 等），與本檔靜態
 * {@link mergeDeviceConfigSidebarMenus} 重複；且 DB 字元集若與 UTF-8 不一致會出現亂碼。
 * 另：020 曾用 990107 作權限葉節點，與前端 {@link DEVICE_CONFIG_MENU_IDS.blenderSimulator} 衝突。
 * 側欄以靜態合併為準，故自 API 樹遞迴剔除上述節點。
 */
function stripShadowedSimulatorMenusFromApi (nodes) {
  if (!Array.isArray(nodes) || !nodes.length) return []
  const stripIds = new Set([
    DEVICE_CONFIG_MENU_IDS.x600hGateway,
    DEVICE_CONFIG_MENU_IDS.simulatorGroup,
    DEVICE_CONFIG_MENU_IDS.xt90c2Simulator,
    DEVICE_CONFIG_MENU_IDS.blenderSimulator,
    DEVICE_CONFIG_MENU_IDS.xosIviSimulator,
    DEVICE_CONFIG_MENU_IDS.hansonIviSimulator
  ])
  const stripEn = new Set(['simulatorGroup', 'x600hGateway', 'xt90c2Simulator', 'blenderSimulator', 'xosIviSimulator', 'hansonIviSimulator', 'deviceSimulatorConsole'])
  function walk (list) {
    const out = []
    for (let i = 0; i < list.length; i++) {
      const n = list[i]
      if (!n || n.id == null) continue
      if (stripIds.has(Number(n.id))) continue
      const en = n.enName != null ? String(n.enName) : ''
      if (en && stripEn.has(en)) continue
      const copy = Object.assign({}, n)
      if (Array.isArray(n.menuList) && n.menuList.length) {
        copy.menuList = walk(n.menuList)
      }
      out.push(copy)
    }
    return out
  }
  return walk(nodes)
}

/**
 * menuApi 已含 patch 035 之 Leo 分組與頁面；{@link mergeDeviceConfigSidebarMenus} 再以靜態樹合併，
 * 若不剔除會出現兩個「Leo 知識庫」及同 id 子項重複。與模擬器 {@link stripShadowedSimulatorMenusFromApi} 同型。
 */
function menuNodeNumericId (n) {
  if (!n || n.id == null || n.id === '') return null
  const num = Number(n.id)
  return Number.isFinite(num) ? num : null
}

function stripShadowedLeoKnowledgeMenusFromApi (nodes) {
  if (!Array.isArray(nodes) || !nodes.length) return []
  function walk (list) {
    const out = []
    for (let i = 0; i < list.length; i++) {
      const n = list[i]
      if (!n || n.id == null) continue
      const nid = menuNodeNumericId(n)
      if (nid != null && LEO_SIDEBAR_STRIP_IDS.has(nid)) continue
      const en = n.enName != null ? String(n.enName) : ''
      if (en && LEO_SIDEBAR_STRIP_EN.has(en)) continue
      const copy = Object.assign({}, n)
      if (Array.isArray(n.menuList) && n.menuList.length) {
        copy.menuList = walk(n.menuList)
      }
      out.push(copy)
    }
    return out
  }
  return walk(nodes)
}

/** 舊版車載 id（990240–990249、990270 CAN 匹配）與 Leo／會員 HQ 衝突；以靜態 990300+ 為準，自 API 樹剔除。 */
const LINUX_AUTO_SIDEBAR_STRIP_EN = new Set([
  'linuxAutoOps',
  'linuxAutoEquipment',
  'linuxAutoRemoteOps',
  'linuxAutoProfileConfig',
  'linuxAutoDataBilling',
  'linuxAutoModelRegistry',
  'linuxAutoPartnerDelivery',
  'linuxAutoFleetMonitor',
  'linuxAutoDbcEntitlement',
  'linuxAutoCabinFeatures',
  'linuxAutoCanAutoMatch'
])

function stripShadowedLinuxAutoMenusFromApi (nodes) {
  if (!Array.isArray(nodes) || !nodes.length) return []
  const keepMin = LINUX_AUTO_MENU_IDS.group
  const keepMax = LINUX_AUTO_MENU_IDS.canAutoMatch
  function walk (list) {
    const out = []
    for (let i = 0; i < list.length; i++) {
      const n = list[i]
      if (!n || n.id == null) continue
      const en = n.enName != null ? String(n.enName).trim() : ''
      const id = Number(n.id)
      if (en && LINUX_AUTO_SIDEBAR_STRIP_EN.has(en) && !(id >= keepMin && id <= keepMax)) {
        continue
      }
      const copy = Object.assign({}, n)
      if (Array.isArray(n.menuList) && n.menuList.length) {
        copy.menuList = walk(n.menuList)
      }
      out.push(copy)
    }
    return out
  }
  return walk(nodes)
}

function leoSidebarLeaf (id, name, enName, icon) {
  const item = { id, name, enName, icon: icon || '' }
  return item
}

function leoSidebarFolder (id, name, enName, children) {
  const menuList = (children || []).filter(Boolean)
  if (!menuList.length) return null
  return { id, name, enName, icon: 'nested', menuList }
}

/** 运维类 Leo 页归入知识库树；系统设置仅保留视觉样板等非业务项 */
function stripLeoOpsFromSystemSettingsSidebar (list) {
  const sys = (list || []).find(x => x && (x.enName === 'systemSetting' || x.name === '系统设置' || x.name === '系統設定'))
  if (!sys || !Array.isArray(sys.menuList)) return
  sys.menuList = sys.menuList.filter(x => {
    if (!x || x.id == null) return false
    if (LEO_OPS_MENU_IDS_IN_SYSTEM_SETTINGS.has(Number(x.id))) return false
    const en = x.enName != null ? String(x.enName).trim() : ''
    if (en && LEO_OPS_STRIP_EN_FROM_SYSTEM.has(en)) return false
    return true
  })
}

/** Leo 知识库侧栏：一级分组 + 二级功能页（menuId／路由不变） */
function buildLeoKnowledgeSidebarTree (leoView, leoUpload) {
  const groups = []

  const portalLeaves = [
    leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.portalHub, 'Leo 對話與營運', 'leoKnowledgePortalHub')
  ]
  if (leoView) {
    portalLeaves.push(
      leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.pipelineHub, '管線總覽', 'leoKnowledgePipelineHub'),
      leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.testerConsole, '測試員主控台', 'leoKnowledgeTesterConsole')
    )
  }
  if (leoUpload) {
    portalLeaves.push(
      leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.xeeGrowthDashboard, 'XEE · Leo 成長', 'leoXeeGrowthDashboard')
    )
  }
  const portalFolder = leoSidebarFolder(
    LEO_SIDEBAR_FOLDER_IDS.portalOverview,
    '門戶與總覽',
    'leoKnowledgeFolderPortal',
    portalLeaves
  )
  if (portalFolder) groups.push(portalFolder)

  if (leoView) {
    const modelFolder = leoSidebarFolder(
      LEO_SIDEBAR_FOLDER_IDS.modelKnowledge,
      '型號與知識',
      'leoKnowledgeFolderModel',
      [
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.modelFields, '型號知識欄位', 'leoKnowledgeModelFields'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.equipmentTypeTypeKey, '設備類型 type_key', 'leoKnowledgeEquipmentTypeTypeKey'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.capabilityMatrix, '能力矩陣', 'leoKnowledgeCapabilityMatrix'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.onboarding, '智慧型號引導', 'leoKnowledgeOnboarding')
      ]
    )
    if (modelFolder) groups.push(modelFolder)
  }

  const ingestLeaves = []
  if (leoUpload) {
    ingestLeaves.push(
      leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.upload, '知識上傳', 'leoKnowledgeUpload'),
      leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.ingestBatch, '入庫批次（自動建立）', 'leoKnowledgeIngestBatch'),
      leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.phase1Ssot, 'Phase1 SSOT 管線', 'leoKnowledgePhase1Ssot')
    )
  }
  if (leoView) {
    ingestLeaves.push(
      leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.learning, '學習閉環', 'leoKnowledgeLearning'),
      leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.externalIngest, '外部知識入庫', 'leoKnowledgeExternalIngest')
    )
  }
  const ingestFolder = leoSidebarFolder(
    LEO_SIDEBAR_FOLDER_IDS.ingestLoop,
    '入庫與閉環',
    'leoKnowledgeFolderIngest',
    ingestLeaves
  )
  if (ingestFolder) groups.push(ingestFolder)

  if (leoView) {
    const protocolFolder = leoSidebarFolder(
      LEO_SIDEBAR_FOLDER_IDS.protocolTools,
      '協議與工具',
      'leoKnowledgeFolderProtocol',
      [
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.featureSurface, '功能→API 映射', 'leoKnowledgeFeatureSurface'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.protocolDoc, '協議文檔索引', 'leoKnowledgeProtocolDoc'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.remoteTool, '遙控工具目錄', 'leoKnowledgeRemoteTools')
      ]
    )
    if (protocolFolder) groups.push(protocolFolder)
  }

  if (leoView || leoUpload) {
    const opsLeaves = []
    if (leoUpload) {
      opsLeaves.push(
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.trainingDecisionDesk, '训练决策台', 'leoTrainingDecisionDesk'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.clawPlanCapabilityHub, 'ClawPlan 能力总览', 'leoClawPlanCapabilityHub'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.trainingFederationCommandCenter, '訓練聯邦總控', 'leoTrainingFederationCommandCenter'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.trainingDashboard, 'T0–T9 訓練總控台', 'leoTrainingDashboard'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.t2GoldenTraining, 'T2 Golden 訓練', 'leoT2GoldenTraining'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.t9DeepseekTraining, 'T9 DeepSeek 訓練', 'leoT9DeepseekTraining'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.portalOpsDailyHub, 'PORTAL_OPS 工作台', 'leoKnowledgePortalOpsDailyHub'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.portalOpsInventoryConsole, 'Portal ops API 盤點台', 'leoKnowledgePortalOpsInventory'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.deviceOpsBLineDailyHub, 'B 線日常工作台', 'leoDeviceOpsBLineDailyHub'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.deviceOpsSemanticTraining, '語義訓練工作台', 'leoDeviceOpsSemanticTraining'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.turnRoutingTraining, 'T0 入口路由訓練台', 'leoTurnRoutingTrainingHub'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.productionE2eTraining, 'T6 生產 E2E 訓練', 'leoProductionE2eTraining'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.deviceOpsReviewInbox, 'B 線審核待辦', 'leoDeviceOpsReviewInbox'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.deviceOpsDescriptionAutogen, 'Device_OPS 盤點台', 'leoDeviceOpsDescriptionAutogen'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.commandOnboardingWizard, '命令定版向导', 'leoCommandOnboardingWizard'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.deviceOpsRolePolicy, '命令權限總表', 'leoDeviceOpsRolePolicy')
      )
    }
    if (leoView || leoUpload) {
      opsLeaves.push(
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.tasteHabitPerception, '口味／习惯感知', 'leoTasteHabitPerception')
      )
    }
    const opsFolder = leoSidebarFolder(
      LEO_SIDEBAR_FOLDER_IDS.opsWorkbench,
      '運維工作台',
      'leoKnowledgeFolderOps',
      opsLeaves
    )
    if (opsFolder) groups.push(opsFolder)
  }

  return groups
}

/** 训练湖宿主（德国/AWS）：仅训练运维页；view 即可见 T6/T0 等（勿与 buildLeoKnowledgeSidebarTree 的 upload 门闸混用） */
function buildTrainingLakeSidebarTree (leoView, leoUpload) {
  if (!leoView && !leoUpload) return []
  const leaves = []
  if (leoView) {
    leaves.push(
      leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.trainingDecisionDesk, '训练决策台', 'leoTrainingDecisionDesk'),
      leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.clawPlanCapabilityHub, 'ClawPlan 能力总览', 'leoClawPlanCapabilityHub'),
      leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.trainingFederationCommandCenter, '训练联邦总控', 'leoTrainingFederationCommandCenter'),
      leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.trainingDashboard, 'T0–T9 训练总控台', 'leoTrainingDashboard'),
      leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.productionE2eTraining, 'T6 生产 E2E 训练', 'leoProductionE2eTraining'),
      leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.tasteHabitPerception, '口味／习惯感知', 'leoTasteHabitPerception'),
      leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.deviceOpsSemanticTraining, '语义训练工作台', 'leoDeviceOpsSemanticTraining'),
      leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.turnRoutingTraining, 'T0 入口路由训练台', 'leoTurnRoutingTrainingHub'),
      leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.t2GoldenTraining, 'T2 Golden 训练', 'leoT2GoldenTraining'),
      leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.t9DeepseekTraining, 'T9 DeepSeek 训练', 'leoT9DeepseekTraining'),
      leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.trainingFederationCases, '联邦样本浏览', 'leoTrainingFederationCases')
    )
  }
  if (leoUpload) {
    leaves.push(
      leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.deviceOpsReviewInbox, 'B 线审核待办', 'leoDeviceOpsReviewInbox')
    )
  }
  const opsFolder = leoSidebarFolder(
    LEO_SIDEBAR_FOLDER_IDS.opsWorkbench,
    '训练运维',
    'leoTrainingLakeFolderOps',
    leaves
  )
  return opsFolder ? [opsFolder] : []
}

function isLegacyApiDeviceConfigRoot (n) {
  return isMixedLegacyDeviceConfigRoot(n)
}

/** 自 API 剔除混掛歷史根：通道葉→channelChildren；Profile 葉→deviceProfileChildren */
function stripLegacyApiDeviceConfigRoot (nodes) {
  if (!Array.isArray(nodes) || !nodes.length) {
    return { tree: [], channelChildren: [], deviceProfileChildren: [] }
  }
  let channelChildren = []
  let deviceProfileChildren = []
  function walk (list) {
    const out = []
    for (let i = 0; i < list.length; i++) {
      const n = list[i]
      if (!n) continue
      if (isLegacyApiDeviceConfigRoot(n)) {
        if (Array.isArray(n.menuList) && n.menuList.length) {
          const split = partitionDeviceChannelLeaves(n.menuList)
          channelChildren = channelChildren.concat(split.channelLeaves.map((c) => Object.assign({}, c)))
          deviceProfileChildren = deviceProfileChildren.concat(split.deviceLeaves.map((c) => Object.assign({}, c)))
        }
        continue
      }
      const copy = Object.assign({}, n)
      if (Array.isArray(n.menuList) && n.menuList.length) {
        copy.menuList = walk(n.menuList)
      }
      out.push(copy)
    }
    return out
  }
  return { tree: walk(nodes), channelChildren, deviceProfileChildren }
}

function menuNodeEnName (n) {
  return n && n.enName != null ? String(n.enName).trim() : ''
}

function isDataCenterSidebarRoot (n) {
  if (!n) return false
  const en = menuNodeEnName(n)
  const name = String(n.name || '')
  return en === 'dataCenter' || name === '数据中心' || name === '數據中心'
}

function findDataCenterSidebarParent (nodes) {
  if (!Array.isArray(nodes)) return null
  for (let i = 0; i < nodes.length; i++) {
    if (isDataCenterSidebarRoot(nodes[i])) return nodes[i]
  }
  return null
}

function isX600hGatewaySidebarLeaf (n) {
  if (!n) return false
  if (Number(n.id) === DEVICE_CONFIG_MENU_IDS.x600hGateway) return true
  const en = menuNodeEnName(n)
  if (en === 'x600hGateway' || en === 'x600hGatewayData') return true
  const name = String(n.name || '')
  if (name === 'X600H' || (name.indexOf('X600H') >= 0 && name.indexOf('Gateway') >= 0)) return true
  const url = String(n.url || '').replace(/^\//, '')
  if (url.indexOf('dataCenter-x600h-gateway') >= 0 || url.indexOf('dataCenter/x600hGateway') >= 0) {
    return true
  }
  return false
}

function isSimulatorGroupSidebarRoot (n) {
  if (!n) return false
  return Number(n.id) === DEVICE_CONFIG_MENU_IDS.simulatorGroup || menuNodeEnName(n) === 'simulatorGroup'
}

/** 僅保留「模擬機」分組內的 X600H；其餘（含數據中心、頂層重複）一律剔除 */
function stripX600hGatewayExceptUnderSimulatorGroup (nodes) {
  if (!Array.isArray(nodes) || !nodes.length) return nodes
  function walk (list, underSimulator) {
    const out = []
    for (let i = 0; i < list.length; i++) {
      const n = list[i]
      if (!n) continue
      const nowUnder = underSimulator || isSimulatorGroupSidebarRoot(n)
      if (!nowUnder && isX600hGatewaySidebarLeaf(n)) continue
      const copy = Object.assign({}, n)
      if (Array.isArray(n.menuList) && n.menuList.length) {
        copy.menuList = walk(n.menuList, nowUnder)
      }
      out.push(copy)
    }
    return out
  }
  return walk(nodes, false)
}

function isDeviceConfigExclusiveLeaf (n) {
  if (!n) return false
  if (isDeviceConfigExclusiveMenuLeaf(n)) return true
  const en = menuNodeEnName(n)
  if (en && DEVICE_CONFIG_SIDEBAR_LEAF_EN.has(en)) return true
  return DEVICE_CONFIG_SIDEBAR_LEAF_IDS.has(Number(n.id))
}

function isChannelConfigExclusiveLeaf (n) {
  if (!n) return false
  if (isChannelConfigExclusiveMenuLeaf(n)) return true
  const en = menuNodeEnName(n)
  return !!(en && CHANNEL_CONFIG_SIDEBAR_LEAF_EN.has(en))
}

function collectSidebarLeafIds (node, idSet) {
  if (!node) return
  const children = Array.isArray(node.menuList) ? node.menuList : []
  if (!children.length) {
    if (node.id != null) idSet.add(Number(node.id))
    return
  }
  for (let i = 0; i < children.length; i++) collectSidebarLeafIds(children[i], idSet)
}

/** 設備配置 vs 通道配置 vs 出品「通道與綁定」去重 */
function dedupeSidebarChannelVsDeviceConfig (list) {
  if (!Array.isArray(list)) return
  const channelGroup = findMenuNodeById(list, CHANNEL_CONFIG_SIDEBAR_IDS.group)
  const deviceGroup = findMenuNodeById(list, DEVICE_CONFIG_MENU_IDS.group)

  if (channelGroup && Array.isArray(channelGroup.menuList)) {
    channelGroup.menuList = channelGroup.menuList.filter((c) => c && !isDeviceConfigExclusiveLeaf(c))
  }

  const channelLeafIds = new Set()
  const channelLeafEns = new Set()
  if (channelGroup) {
    collectSidebarLeafIds(channelGroup, channelLeafIds)
    for (let i = 0; i < (channelGroup.menuList || []).length; i++) {
      const en = menuNodeEnName(channelGroup.menuList[i])
      if (en) channelLeafEns.add(en)
    }
  }

  if (deviceGroup && Array.isArray(deviceGroup.menuList)) {
    deviceGroup.menuList = deviceGroup.menuList.filter((c) => {
      if (!c) return false
      if (isChannelConfigExclusiveLeaf(c)) return false
      if (channelLeafIds.has(Number(c.id))) return false
      const en = menuNodeEnName(c)
      if (en && channelLeafEns.has(en)) return false
      return true
    })
  }

  const stripElsewhere = (n) => {
    if (!n) return false
    if (channelLeafIds.has(Number(n.id))) return true
    return isChannelConfigExclusiveLeaf(n)
  }

  function walkPrune (nodes, underChannelGroup) {
    if (!Array.isArray(nodes)) return []
    const out = []
    for (let i = 0; i < nodes.length; i++) {
      const n = nodes[i]
      if (!n) continue
      const inChannel = underChannelGroup || Number(n.id) === CHANNEL_CONFIG_SIDEBAR_IDS.group
      const children = Array.isArray(n.menuList) ? n.menuList : []
      if (!children.length) {
        if (!inChannel && stripElsewhere(n)) continue
        out.push(n)
        continue
      }
      const pruned = walkPrune(children, inChannel)
      if (!inChannel && stripElsewhere(n) && !pruned.length) continue
      out.push(Object.assign({}, n, { menuList: pruned }))
    }
    return out
  }

  const pruned = walkPrune(list, false)
  list.length = 0
  for (let i = 0; i < pruned.length; i++) list.push(pruned[i])

  if (channelGroup && (!channelGroup.menuList || !channelGroup.menuList.length)) {
    const idx = list.findIndex((x) => x && Number(x.id) === CHANNEL_CONFIG_SIDEBAR_IDS.group)
    if (idx >= 0) list.splice(idx, 1)
  }
}

function mergeChannelConfigSidebarMenu (list, channelChildren) {
  const kids = (Array.isArray(channelChildren) ? channelChildren : [])
    .filter((c) => c && !isDeviceConfigExclusiveLeaf(c))
  if (!kids.length) return
  if (menuTreeContainsNodeId(list, CHANNEL_CONFIG_SIDEBAR_IDS.group)) return
  list.push({
    id: CHANNEL_CONFIG_SIDEBAR_IDS.group,
    name: '通道配置',
    enName: 'channelConfiguration',
    icon: 'link',
    menuList: kids
  })
}

/** 侧栏菜单设计 SSOT：nav 授权内容不变，按产品设计重组树形（角色授权树仍用 DB parentId） */
function mergeDeviceConfigSidebarMenus (apiMenuList) {
  const raw = Array.isArray(apiMenuList) ? apiMenuList : []
  const legacyDeviceConfig = stripLegacyApiDeviceConfigRoot(raw.slice())
  let list = stripShadowedSimulatorMenusFromApi(legacyDeviceConfig.tree)
  list = stripShadowedLeoKnowledgeMenusFromApi(list)
  list = stripShadowedLinuxAutoMenusFromApi(list)
  stripLeoOpsFromSystemSettingsSidebar(list)
  if (isTrainingLakeHost()) {
    const { leoView, leoUpload } = resolveLeoKnowledgeSidebarGates(raw)
    if (leoView || leoUpload) {
      const leoMenuList = buildTrainingLakeSidebarTree(leoView, leoUpload)
      if (leoMenuList.length) {
        list = list.filter((n) => menuNodeNumericId(n) !== LEO_KNOWLEDGE_MENU_IDS.group)
        list.push({
          id: LEO_KNOWLEDGE_MENU_IDS.group,
          name: '训练湖',
          enName: 'leoTrainingLakeGroup',
          icon: 'chart',
          menuList: leoMenuList
        })
      }
    }
    applySidebarRbacFilter(list, raw)
    fillSidebarMenuIcons(list)
    return list
  }
  if (apiMenuTreeContainsDeviceConfigRoot(raw) &&
      !menuTreeContainsNodeId(list, LEGACY_CHANNEL_CONFIG_API_ROOT_ID) &&
      !menuTreeContainsNodeId(list, DEVICE_CONFIG_MENU_IDS.group)) {
    const deviceKids = (legacyDeviceConfig.deviceProfileChildren || []).filter(Boolean)
    if (deviceKids.length) {
      list.push({
        id: DEVICE_CONFIG_MENU_IDS.group,
        name: '設備配置',
        enName: 'deviceConfig',
        icon: 'machine',
        menuList: deviceKids.map((c) => Object.assign({}, c))
      })
    }
  }
  mergeChannelConfigSidebarMenu(list, legacyDeviceConfig.channelChildren)
  const navAllowsSimulator = apiMenuTreeContainsSimulatorMerge(raw)
  if (navAllowsSimulator && hasSimulatorSidebarPermission()) {
    list.push({
      id: DEVICE_CONFIG_MENU_IDS.simulatorGroup,
      name: '模擬機',
      enName: 'simulatorGroup',
      icon: 'machine_model',
      menuList: [
        {
          id: DEVICE_CONFIG_MENU_IDS.x600hGateway,
          name: 'X600H',
          enName: 'x600hGateway',
          icon: ''
        },
        {
          id: DEVICE_CONFIG_MENU_IDS.xt90c2Simulator,
          name: 'XT90C2',
          enName: 'xt90c2Simulator',
          icon: ''
        },
        {
          id: DEVICE_CONFIG_MENU_IDS.blenderSimulator,
          name: 'Blender',
          enName: 'blenderSimulator',
          icon: ''
        },
        {
          id: DEVICE_CONFIG_MENU_IDS.xosIviSimulator,
          name: 'XOS',
          enName: 'xosIviSimulator',
          icon: ''
        },
        {
          id: DEVICE_CONFIG_MENU_IDS.hansonIviSimulator,
          name: 'Hansong IVI',
          enName: 'hansonIviSimulator',
          icon: ''
        }
      ]
    })
  }
  const { leoView, leoUpload } = resolveLeoKnowledgeSidebarGates(raw)
  if (navAllowsSimulator && hasSimulatorSidebarPermission()) {
    const sysForUi = list.find(x => x && (x.enName === 'systemSetting' || x.name === '系统设置' || x.name === '系統設定'))
    if (sysForUi && Array.isArray(sysForUi.menuList) && !menuTreeContainsNodeId(list, DEVICE_CONFIG_MENU_IDS.deviceLinkDebug)) {
      sysForUi.menuList.push({
        id: DEVICE_CONFIG_MENU_IDS.deviceLinkDebug,
        name: '设备通信调试',
        enName: 'deviceLinkDebug',
        icon: 'link'
      })
    }
  }
  if (leoView || leoUpload) {
    const sysForUi = list.find(x => x && (x.enName === 'systemSetting' || x.name === '系统设置' || x.name === '系統設定'))
    if (sysForUi && Array.isArray(sysForUi.menuList) && !menuTreeContainsNodeId(list, LEO_KNOWLEDGE_MENU_IDS.uiSurfaceSample)) {
      sysForUi.menuList.push({
        id: LEO_KNOWLEDGE_MENU_IDS.uiSurfaceSample,
        name: '後台視覺樣板（灰底）',
        enName: 'leoKnowledgeUiSurfaceSample',
        icon: 'theme'
      })
    }
    if (leoUpload && sysForUi && Array.isArray(sysForUi.menuList)
        && !menuTreeContainsNodeId(list, LEO_KNOWLEDGE_MENU_IDS.aiTrusteeAdmin)) {
      sysForUi.menuList.unshift({
        id: LEO_KNOWLEDGE_MENU_IDS.aiTrusteeAdmin,
        name: 'AI 托管管理台',
        enName: 'aiTrusteeAdmin',
        icon: 'switch'
      })
    }
  }
  if (leoView || leoUpload) {
    const leoMenuList = buildLeoKnowledgeSidebarTree(leoView, leoUpload)
    if (leoMenuList.length) {
      list.push({
        id: LEO_KNOWLEDGE_MENU_IDS.group,
        name: 'Leo 知識庫',
        enName: 'leoKnowledgeGroup',
        icon: 'documentation',
        menuList: leoMenuList
      })
    }
  }
  mergeMemberHqMenu(list)
  mergeMerchantTokenBillingPlatformMenu(list)
  mergeMerchantDataBillingPlatformMenu(list)
  mergeProduceFivePosMenu(list)
  mergeDataCenterCoffeeMachineMenus(list, raw)
  mergeProductCenterSidebarTree(list)
  mergeLinuxAutoOpsMenu(list)
  dedupeSidebarChannelVsDeviceConfig(list)
  list = stripX600hGatewayExceptUnderSimulatorGroup(list)
  mergeX600hProductionOrderSidebar(list)
  applySidebarRbacFilter(list, raw)
  fillSidebarMenuIcons(list)
  return list
}

/** 设备管理侧栏：X600H 生产订单 — 仅 x600h:production-order:* 或 nav 已授权 */
function mergeX600hProductionOrderSidebar (list) {
  if (!Array.isArray(list)) return
  if (!canAccessX600hProductionOrderMenu()) return
  if (menuTreeContainsNodeId(list, X600H_PRODUCTION_ORDER_MENU_IDS.list)) return
  const devicesGroup = list.find(
    (x) =>
      x &&
      (x.enName === 'devices' ||
        x.enName === 'device' ||
        x.name === '设备管理' ||
        x.name === '設備管理' ||
        x.name === '设备')
  )
  if (!devicesGroup) return
  if (!Array.isArray(devicesGroup.menuList)) devicesGroup.menuList = []
  devicesGroup.menuList.push({
    id: X600H_PRODUCTION_ORDER_MENU_IDS.list,
    name: 'X600H 生产订单',
    enName: 'x600hProductionOrder',
    icon: 'machine_model'
  })
}

/** 與 extras 的 path 比較用（有無前導 / 視為同一路由） */
function pathKey (p) {
  return String(p == null ? '' : p).replace(/^\//, '')
}

/**
 * 靜態子路由在前、動態在後；依 name／path 去重（先出現者保留，即靜態優先）。
 * 禁止子路由 name 為 main（與父級 Layout 路由 name: main 衝突，vue-router 會報 Duplicate named routes）。
 */
function dedupeMainChildrenFirstWins (children) {
  const seenName = new Set()
  const seenPath = new Set()
  const out = []
  for (var i = 0; i < children.length; i++) {
    const c = children[i]
    if (!c) continue
    if (c.name === 'main') continue
    const pk = pathKey(c.path)
    if (c.name && seenName.has(c.name)) continue
    if (pk && seenPath.has(pk)) continue
    if (c.name) seenName.add(c.name)
    if (pk) seenPath.add(pk)
    out.push(c)
  }
  return out
}

/**
 * 靜態 main 子路由已在 Router 初始註冊；後端 menu 與 appendStaticDeviceConfigRoutes 的 extras
 * 常與 STATIC_MAIN_CHILDREN_SNAPSHOT 同名／同 path，若直接 concat 再 addRoute 會觸發 Duplicate named routes。
 */
function dedupeDynamicRoutesAgainstStatic (dynamicRoutes) {
  const staticList = STATIC_MAIN_CHILDREN_SNAPSHOT
  const staticNames = new Set()
  const staticPathKeys = new Set()
  for (var si = 0; si < staticList.length; si++) {
    var st = staticList[si]
    if (!st) continue
    if (st.name) staticNames.add(st.name)
    var spk = pathKey(st.path)
    if (spk) staticPathKeys.add(spk)
  }
  const seenName = new Set()
  const seenPath = new Set()
  const out = []
  for (var k = 0; k < dynamicRoutes.length; k++) {
    var r = dynamicRoutes[k]
    if (!r) continue
    if (r.name === 'main') continue
    var pk = pathKey(r.path)
    if (r.name && staticNames.has(r.name)) continue
    if (pk && staticPathKeys.has(pk)) continue
    if (r.name && seenName.has(r.name)) continue
    if (pk && seenPath.has(pk)) continue
    if (r.name) seenName.add(r.name)
    if (pk) seenPath.add(pk)
    out.push(r)
  }
  return out
}

/**
 * 設備配置在線化：合併進動態路由（無後台選單項時仍可進入），對齊 DEVICE_CONFIG_UI_STANDARD_V1。
 * 若 menuApi 已寫入同名 path / name 但 _import 失敗（component 空），舊邏輯會「跳過」靜態 extras → 導向 * 回退 404。
 * 此處改為先移除衝突項再寫入正確靜態路由，確保可進入。
 */
function appendStaticDeviceConfigRoutes (routes) {
  const extras = [
    {
      path: '/deviceConfig-profileList',
      component: _import('deviceConfig/profileList'),
      name: 'deviceConfig-profileList',
      meta: {
        title: '配置檔庫',
        isTab: true,
        isDynamic: false,
        menuId: DEVICE_CONFIG_MENU_IDS.profileList,
        id: DEVICE_CONFIG_MENU_IDS.profileList
      }
    },
    {
      path: '/deviceConfig-profileWorkbench',
      component: _import('deviceConfig/profileWorkbench'),
      name: 'deviceConfig-profileWorkbench',
      meta: {
        title: 'Profile 工作台',
        isTab: true,
        isDynamic: false,
        menuId: DEVICE_CONFIG_MENU_IDS.workbench,
        id: DEVICE_CONFIG_MENU_IDS.workbench
      }
    },
    {
      path: '/deviceConfig-bindings',
      component: _import('deviceConfig/bindings'),
      name: 'deviceConfig-bindings',
      meta: {
        title: '配置綁定與下發',
        isTab: true,
        isDynamic: false,
        menuId: DEVICE_CONFIG_MENU_IDS.bindings,
        id: DEVICE_CONFIG_MENU_IDS.bindings
      }
    },
    {
      path: '/deviceConfig-coffeeMachineChannels',
      component: _import('deviceConfig/coffeeMachineChannelConfig'),
      name: 'deviceConfig-coffeeMachineChannels',
      meta: {
        title: '咖啡機配方中心',
        isTab: true,
        isDynamic: false,
        menuId: DEVICE_CONFIG_MENU_IDS.coffeeMachineChannels,
        id: DEVICE_CONFIG_MENU_IDS.coffeeMachineChannels
      }
    },
    {
      path: '/device-x600h-production-order',
      component: _import('device/x600hProductionOrder/index'),
      name: 'x600hProductionOrder',
      meta: {
        title: 'X600H 生产订单',
        isTab: true,
        isDynamic: false,
        menuId: X600H_PRODUCTION_ORDER_MENU_IDS.list,
        id: X600H_PRODUCTION_ORDER_MENU_IDS.list
      }
    },
    {
      path: '/dataCenter-x600h-gateway',
      component: _import('dataCenter/x600hGateway/index'),
      name: 'x600hGatewayData',
      meta: {
        title: 'X600H',
        isTab: true,
        isDynamic: false,
        menuId: DEVICE_CONFIG_MENU_IDS.x600hGateway,
        id: DEVICE_CONFIG_MENU_IDS.x600hGateway
      }
    },
    {
      path: '/simulator-xt90c2',
      component: _import('dataCenter/x600hGateway/index'),
      name: 'xt90c2Simulator',
      meta: {
        title: 'XT90C2 模擬機',
        isTab: true,
        isDynamic: false,
        menuId: DEVICE_CONFIG_MENU_IDS.xt90c2Simulator,
        id: DEVICE_CONFIG_MENU_IDS.xt90c2Simulator
      }
    },
    {
      path: '/simulator-blender',
      component: _import('simulator/blender/index'),
      name: 'blenderSimulator',
      meta: {
        title: 'Blender 模擬機',
        isTab: true,
        isDynamic: false,
        menuId: DEVICE_CONFIG_MENU_IDS.blenderSimulator,
        id: DEVICE_CONFIG_MENU_IDS.blenderSimulator
      }
    },
    {
      path: '/simulator-xos-ivi',
      component: _import('simulator/xosIvi/index'),
      name: 'xosIviSimulator',
      meta: {
        title: 'XOS 模擬機',
        isTab: true,
        isDynamic: false,
        menuId: DEVICE_CONFIG_MENU_IDS.xosIviSimulator,
        id: DEVICE_CONFIG_MENU_IDS.xosIviSimulator
      }
    },
    {
      path: '/simulator-hanson-ivi',
      component: _import('simulator/hansonIvi/index'),
      name: 'hansonIviSimulator',
      meta: {
        title: 'Hansong IVI 模擬機',
        isTab: true,
        isDynamic: false,
        menuId: DEVICE_CONFIG_MENU_IDS.hansonIviSimulator,
        id: DEVICE_CONFIG_MENU_IDS.hansonIviSimulator
      }
    },
    {
      path: '/leo-knowledge-portal-hub',
      component: _import('leoKnowledge/LeoPortalAndConsoleHub'),
      name: 'leoKnowledgePortalHub',
      meta: {
        title: i18n.t('route.leoKnowledgePortalHub'),
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.portalHub,
        id: LEO_KNOWLEDGE_MENU_IDS.portalHub,
        leoKnowledgeAnyOf: [LEO_KNOWLEDGE_PERM_CODES.VIEW, LEO_KNOWLEDGE_PERM_CODES.UPLOAD]
      }
    },
    {
      path: '/leo-in-car',
      component: _import('leoKnowledge/LeoInCarHub'),
      name: 'leoInCarHub',
      meta: {
        title: 'Leo.in.Car',
        isTab: true,
        isDynamic: false,
        leoKnowledgeAnyOf: [LEO_KNOWLEDGE_PERM_CODES.VIEW, LEO_KNOWLEDGE_PERM_CODES.UPLOAD]
      }
    },
    {
      path: '/leo-at-home',
      component: _import('leoKnowledge/LeoAtHomeHub'),
      name: 'leoAtHomeHub',
      meta: {
        title: 'Leo.at.Home',
        isTab: true,
        isDynamic: false,
        leoKnowledgeAnyOf: [LEO_KNOWLEDGE_PERM_CODES.VIEW, LEO_KNOWLEDGE_PERM_CODES.UPLOAD]
      }
    },
    {
      path: '/leo-in-biz',
      component: _import('leoKnowledge/LeoInBizHub'),
      name: 'leoInBizHub',
      meta: {
        title: 'Leo.in.Biz',
        isTab: true,
        isDynamic: false,
        leoKnowledgeAnyOf: [LEO_KNOWLEDGE_PERM_CODES.VIEW, LEO_KNOWLEDGE_PERM_CODES.UPLOAD]
      }
    },
    {
      path: '/ui-surface-sample',
      component: _import('common/UiSurfaceSample'),
      name: 'leoKnowledgeUiSurfaceSample',
      meta: {
        title: i18n.t('route.leoKnowledgeUiSurfaceSample'),
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.uiSurfaceSample,
        id: LEO_KNOWLEDGE_MENU_IDS.uiSurfaceSample,
        leoKnowledgeAnyOf: [LEO_KNOWLEDGE_PERM_CODES.VIEW, LEO_KNOWLEDGE_PERM_CODES.UPLOAD]
      }
    },
    {
      path: '/system-ai-trustee-admin',
      beforeEnter (to, from, next) {
        if (to.query && to.query.tab === 'taste_habit') {
          const q = { ...to.query }
          delete q.tab
          next({ path: '/leo-taste-habit-perception', query: q })
          return
        }
        next()
      },
      component: _import('systemSetting/AiTrusteeAdminConsole'),
      name: 'aiTrusteeAdminConsole',
      meta: {
        title: i18n.t('route.aiTrusteeAdmin'),
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.aiTrusteeAdmin,
        id: LEO_KNOWLEDGE_MENU_IDS.aiTrusteeAdmin,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.UPLOAD
      }
    },
    {
      path: '/system-agent-permission-steward',
      component: _import('systemSetting/AgentPermissionStewardConsole'),
      name: 'agentPermissionStewardConsole',
      meta: {
        title: i18n.t('route.agentPermissionSteward'),
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.agentPermissionSteward,
        id: LEO_KNOWLEDGE_MENU_IDS.agentPermissionSteward
      }
    },
    {
      path: '/system-platform-release-control',
      component: _import('systemSetting/PlatformReleaseControlConsole'),
      name: 'platformReleaseControlConsole',
      meta: {
        title: '發版總管',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.platformReleaseControl,
        id: LEO_KNOWLEDGE_MENU_IDS.platformReleaseControl
      }
    },
    {
      path: '/system-equipment-model-repair',
      component: _import('systemSetting/equipmentModelRepair/index'),
      name: 'equipmentModelRepairConsole',
      meta: {
        title: '設備型號修復',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.equipmentModelRepair,
        id: LEO_KNOWLEDGE_MENU_IDS.equipmentModelRepair
      }
    },
    {
      path: '/leo-knowledge-model-fields',
      component: _import('leoKnowledge/ModelKnowledgeForm'),
      name: 'leoKnowledgeModelFields',
      meta: {
        title: '型號知識欄位',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.modelFields,
        id: LEO_KNOWLEDGE_MENU_IDS.modelFields,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.VIEW
      }
    },
    {
      path: '/leo-knowledge-equipment-type-typekey',
      component: _import('leoKnowledge/EquipmentTypeTypeKeyAdmin'),
      name: 'leoKnowledgeEquipmentTypeTypeKey',
      meta: {
        title: '設備類型 type_key',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.equipmentTypeTypeKey,
        id: LEO_KNOWLEDGE_MENU_IDS.equipmentTypeTypeKey,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.VIEW
      }
    },
    {
      path: '/leo-knowledge-upload',
      component: _import('leoKnowledge/KnowledgeUpload'),
      name: 'leoKnowledgeUpload',
      meta: {
        title: '知識上傳',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.upload,
        id: LEO_KNOWLEDGE_MENU_IDS.upload,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.UPLOAD
      }
    },
    {
      path: '/leo-knowledge-ingest-batch',
      component: _import('leoKnowledge/IngestBatch'),
      name: 'leoKnowledgeIngestBatch',
      meta: {
        title: '入庫批次（自動建立）',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.ingestBatch,
        id: LEO_KNOWLEDGE_MENU_IDS.ingestBatch,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.UPLOAD
      }
    },
    {
      path: '/leo-knowledge-phase1-ssot',
      component: _import('leoKnowledge/Phase1SsotTrigger'),
      name: 'leoKnowledgePhase1Ssot',
      meta: {
        title: 'Phase1 SSOT 管線',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.phase1Ssot,
        id: LEO_KNOWLEDGE_MENU_IDS.phase1Ssot,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.UPLOAD
      }
    },
    {
      path: '/leo-knowledge-capability-matrix',
      component: _import('leoKnowledge/CapabilityMatrix'),
      name: 'leoKnowledgeCapabilityMatrix',
      meta: {
        title: '能力矩陣',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.capabilityMatrix,
        id: LEO_KNOWLEDGE_MENU_IDS.capabilityMatrix,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.VIEW
      }
    },
    {
      path: '/leo-taste-habit-perception',
      component: _import('leoKnowledge/TasteHabitPerceptionEditor'),
      name: 'leoTasteHabitPerception',
      meta: {
        title: '口味／习惯感知',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.tasteHabitPerception,
        id: LEO_KNOWLEDGE_MENU_IDS.tasteHabitPerception,
        leoKnowledgeAnyOf: [LEO_KNOWLEDGE_PERM_CODES.VIEW, LEO_KNOWLEDGE_PERM_CODES.UPLOAD]
      }
    },
    {
      path: '/leo-t7-taste-ml',
      component: _import('leoKnowledge/T7TasteMlWorkbench'),
      name: 'leoT7TasteMl',
      meta: {
        title: 'T7 口味 ML',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.t7TasteMl,
        id: LEO_KNOWLEDGE_MENU_IDS.t7TasteMl,
        leoKnowledgeAnyOf: [LEO_KNOWLEDGE_PERM_CODES.VIEW, LEO_KNOWLEDGE_PERM_CODES.UPLOAD]
      }
    },
    {
      path: '/leo-knowledge-onboarding',
      component: _import('leoKnowledge/onboarding/index'),
      name: 'leoKnowledgeOnboarding',
      meta: {
        title: '智慧型號引導',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.onboarding,
        id: LEO_KNOWLEDGE_MENU_IDS.onboarding,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.VIEW
      }
    },
    {
      path: '/leo-tester-console',
      component: _import('leoKnowledge/TesterConsole'),
      name: 'leoKnowledgeTesterConsole',
      meta: {
        title: '測試員主控台',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.testerConsole,
        id: LEO_KNOWLEDGE_MENU_IDS.testerConsole,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.VIEW
      }
    },
    {
      path: '/leo-knowledge-pipeline-hub',
      component: _import('leoKnowledge/pipeline/PipelineHub'),
      name: 'leoKnowledgePipelineHub',
      meta: {
        title: 'Leo 管線總覽',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.pipelineHub,
        id: LEO_KNOWLEDGE_MENU_IDS.pipelineHub,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.VIEW
      }
    },
    {
      path: '/leo-knowledge-feature-surface',
      component: _import('leoKnowledge/pipeline/FeatureSurfaceMap'),
      name: 'leoKnowledgeFeatureSurface',
      meta: {
        title: '功能→API 映射',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.featureSurface,
        id: LEO_KNOWLEDGE_MENU_IDS.featureSurface,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.VIEW
      }
    },
    {
      path: '/leo-knowledge-protocol-index',
      component: _import('leoKnowledge/pipeline/ProtocolDocIndex'),
      name: 'leoKnowledgeProtocolDoc',
      meta: {
        title: '協議文檔索引',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.protocolDoc,
        id: LEO_KNOWLEDGE_MENU_IDS.protocolDoc,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.VIEW
      }
    },
    {
      path: '/leo-knowledge-remote-tools',
      component: _import('leoKnowledge/pipeline/RemoteToolCatalog'),
      name: 'leoKnowledgeRemoteTools',
      meta: {
        title: '遙控工具目錄',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.remoteTool,
        id: LEO_KNOWLEDGE_MENU_IDS.remoteTool,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.VIEW
      }
    },
    {
      path: '/leo-xee-growth',
      component: _import('leoKnowledge/XeeGrowthDashboard'),
      name: 'leoXeeGrowthDashboard',
      meta: {
        title: 'XEE · Leo 成長',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.xeeGrowthDashboard,
        id: LEO_KNOWLEDGE_MENU_IDS.xeeGrowthDashboard,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.VIEW
      }
    },
    {
      path: '/leo-device-ops-b-line-daily-hub',
      component: _import('leoKnowledge/DeviceOpsBLineDailyHub'),
      name: 'leoDeviceOpsBLineDailyHub',
      meta: {
        title: i18n.t('route.leoDeviceOpsBLineDailyHub'),
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.deviceOpsBLineDailyHub,
        id: LEO_KNOWLEDGE_MENU_IDS.deviceOpsBLineDailyHub,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.UPLOAD
      }
    },
    {
      path: '/leo-device-ops-semantic-training',
      component: _import('leoKnowledge/DeviceOpsSemanticTraining'),
      name: 'leoDeviceOpsSemanticTraining',
      meta: {
        title: 'device_ops 語義訓練台',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.deviceOpsSemanticTraining,
        id: LEO_KNOWLEDGE_MENU_IDS.deviceOpsSemanticTraining,
        leoKnowledgeAnyOf: [LEO_KNOWLEDGE_PERM_CODES.VIEW, LEO_KNOWLEDGE_PERM_CODES.UPLOAD]
      }
    },
    {
      path: '/leo-training-decision-desk',
      component: _import('leoKnowledge/LeoTrainingDecisionDesk'),
      name: 'leoTrainingDecisionDesk',
      meta: {
        title: '训练决策台',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.trainingDecisionDesk,
        id: LEO_KNOWLEDGE_MENU_IDS.trainingDecisionDesk,
        leoKnowledgeAnyOf: [LEO_KNOWLEDGE_PERM_CODES.VIEW, LEO_KNOWLEDGE_PERM_CODES.UPLOAD]
      }
    },
    {
      path: '/leo-clawplan-capability-hub',
      component: _import('leoKnowledge/LeoClawPlanCapabilityHub'),
      name: 'leoClawPlanCapabilityHub',
      meta: {
        title: 'ClawPlan 能力总览',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.clawPlanCapabilityHub,
        id: LEO_KNOWLEDGE_MENU_IDS.clawPlanCapabilityHub,
        leoKnowledgeAnyOf: [LEO_KNOWLEDGE_PERM_CODES.VIEW, LEO_KNOWLEDGE_PERM_CODES.UPLOAD]
      }
    },
    {
      path: '/leo-training-federation-command-center',
      component: _import('leoKnowledge/LeoTrainingFederationCommandCenter'),
      name: 'leoTrainingFederationCommandCenter',
      meta: {
        title: '訓練聯邦總控',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.trainingFederationCommandCenter,
        id: LEO_KNOWLEDGE_MENU_IDS.trainingFederationCommandCenter,
        leoKnowledgeAnyOf: [LEO_KNOWLEDGE_PERM_CODES.VIEW, LEO_KNOWLEDGE_PERM_CODES.UPLOAD]
      }
    },
    {
      path: '/leo-usage-habit-wizard-metrics',
      component: _import('leoKnowledge/UsageHabitWizardMetrics'),
      name: 'leoUsageHabitWizardMetrics',
      meta: {
        title: '使用習慣引導漏斗',
        isTab: true,
        isDynamic: false,
        menuId: '990280',
        id: '990280',
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.VIEW
      }
    },
    {
      path: '/leo-training-dashboard',
      component: _import('leoKnowledge/LeoTrainingDashboard'),
      name: 'leoTrainingDashboard',
      meta: {
        title: 'T0–T9 訓練總控台',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.trainingDashboard,
        id: LEO_KNOWLEDGE_MENU_IDS.trainingDashboard,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.VIEW
      }
    },
    {
      path: '/leo-t2-golden-training',
      component: _import('leoKnowledge/T2GoldenTraining'),
      name: 'leoT2GoldenTraining',
      meta: {
        title: 'T2 Golden 訓練',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.t2GoldenTraining,
        id: LEO_KNOWLEDGE_MENU_IDS.t2GoldenTraining,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.VIEW
      }
    },
    {
      path: '/leo-t9-deepseek-training',
      component: _import('leoKnowledge/T9DeepseekTraining'),
      name: 'leoT9DeepseekTraining',
      meta: {
        title: 'T9 DeepSeek 訓練',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.t9DeepseekTraining,
        id: LEO_KNOWLEDGE_MENU_IDS.t9DeepseekTraining,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.VIEW
      }
    },
    {
      path: '/leo-production-e2e-training',
      component: _import('leoKnowledge/ProductionE2eTraining'),
      name: 'leoProductionE2eTraining',
      meta: {
        title: 'T6 生產 E2E 訓練',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.productionE2eTraining,
        id: LEO_KNOWLEDGE_MENU_IDS.productionE2eTraining,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.VIEW
      }
    },
    {
      path: '/leo-training-federation-cases',
      component: _import('leoKnowledge/ProductionE2eTraining'),
      name: 'leoTrainingFederationCases',
      meta: {
        title: '联邦样本浏览',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.trainingFederationCases,
        id: LEO_KNOWLEDGE_MENU_IDS.trainingFederationCases,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.VIEW
      }
    },
    {
      path: '/leo-turn-routing-training',
      component: _import('leoKnowledge/TurnRoutingTrainingHub'),
      name: 'leoTurnRoutingTrainingHub',
      meta: {
        title: i18n.t('route.leoTurnRoutingTrainingHub'),
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.turnRoutingTraining,
        id: LEO_KNOWLEDGE_MENU_IDS.turnRoutingTraining,
        leoKnowledgeAnyOf: [LEO_KNOWLEDGE_PERM_CODES.VIEW, LEO_KNOWLEDGE_PERM_CODES.UPLOAD]
      }
    },
    {
      path: '/leo-portal-ops-daily-hub',
      component: _import('leoKnowledge/PortalOpsDailyHub'),
      name: 'leoKnowledgePortalOpsDailyHub',
      meta: {
        title: i18n.t('route.leoKnowledgePortalOpsDailyHub'),
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.portalOpsDailyHub,
        id: LEO_KNOWLEDGE_MENU_IDS.portalOpsDailyHub,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.UPLOAD
      }
    },
    {
      path: '/leo-portal-ops-api-inventory',
      component: _import('leoKnowledge/PortalOpsInventoryConsole'),
      name: 'leoKnowledgePortalOpsInventory',
      meta: {
        title: i18n.t('route.leoKnowledgePortalOpsInventory'),
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.portalOpsInventoryConsole,
        id: LEO_KNOWLEDGE_MENU_IDS.portalOpsInventoryConsole,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.UPLOAD
      }
    },
    {
      path: '/leo-device-ops-review-inbox',
      component: _import('leoKnowledge/DeviceOpsReviewInbox'),
      name: 'leoDeviceOpsReviewInbox',
      meta: {
        title: i18n.t('route.leoDeviceOpsReviewInbox'),
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.deviceOpsReviewInbox,
        id: LEO_KNOWLEDGE_MENU_IDS.deviceOpsReviewInbox,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.UPLOAD
      }
    },
    {
      path: '/leo-command-onboarding-wizard',
      component: _import('leoKnowledge/CommandOnboardingWizard'),
      name: 'leoCommandOnboardingWizard',
      meta: {
        title: '命令定版向导',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.commandOnboardingWizard,
        id: LEO_KNOWLEDGE_MENU_IDS.commandOnboardingWizard,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.UPLOAD
      }
    },
    {
      path: '/leo-device-ops-description-autogen',
      component: _import('leoKnowledge/DeviceOpsDescriptionAutogen'),
      name: 'leoDeviceOpsDescriptionAutogen',
      meta: {
        title: i18n.t('route.leoDeviceOpsDescriptionAutogen'),
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.deviceOpsDescriptionAutogen,
        id: LEO_KNOWLEDGE_MENU_IDS.deviceOpsDescriptionAutogen,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.UPLOAD
      }
    },
    {
      path: '/leo-device-ops-role-policy',
      component: _import('leoKnowledge/DeviceOpsRolePolicy'),
      name: 'leoDeviceOpsRolePolicy',
      meta: {
        title: '命令權限總表',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.deviceOpsRolePolicy,
        id: LEO_KNOWLEDGE_MENU_IDS.deviceOpsRolePolicy,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.UPLOAD
      }
    },
    {
      path: '/leo-knowledge-learning',
      component: _import('leoKnowledge/pipeline/LearningOutcomes'),
      name: 'leoKnowledgeLearning',
      meta: {
        title: '學習閉環',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.learning,
        id: LEO_KNOWLEDGE_MENU_IDS.learning,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.VIEW
      }
    },
    {
      path: '/leo-knowledge-external-ingest',
      component: _import('leoKnowledge/pipeline/ExternalKnowledgeIngest'),
      name: 'leoKnowledgeExternalIngest',
      meta: {
        title: '外部知識入庫',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.externalIngest,
        id: LEO_KNOWLEDGE_MENU_IDS.externalIngest,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.VIEW
      }
    },
    {
      path: '/linuxAuto-equipment',
      component: _import('linuxAuto/equipment/index'),
      name: 'linuxAuto-equipment',
      meta: {
        title: '車載設備',
        isTab: true,
        isDynamic: false,
        menuId: LINUX_AUTO_MENU_IDS.equipment,
        id: LINUX_AUTO_MENU_IDS.equipment
      }
    },
    {
      path: '/linuxAuto-remoteOps',
      component: _import('linuxAuto/remoteOps/index'),
      name: 'linuxAuto-remoteOps',
      meta: {
        title: '遠程運維',
        isTab: true,
        isDynamic: false,
        menuId: LINUX_AUTO_MENU_IDS.remoteOps,
        id: LINUX_AUTO_MENU_IDS.remoteOps
      }
    },
    {
      path: '/linuxAuto-profileConfig',
      component: _import('linuxAuto/profileConfig/index'),
      name: 'linuxAuto-profileConfig',
      meta: {
        title: 'Profile 配置',
        isTab: true,
        isDynamic: false,
        menuId: LINUX_AUTO_MENU_IDS.profileConfig,
        id: LINUX_AUTO_MENU_IDS.profileConfig
      }
    },
    {
      path: '/linuxAuto-dataBilling',
      component: _import('linuxAuto/dataBilling/index'),
      name: 'linuxAuto-dataBilling',
      meta: {
        title: 'CAN 數據帳單',
        isTab: true,
        isDynamic: false,
        menuId: LINUX_AUTO_MENU_IDS.dataBilling,
        id: LINUX_AUTO_MENU_IDS.dataBilling
      }
    },
    {
      path: '/linuxAuto-modelRegistry',
      component: _import('linuxAuto/modelRegistry/index'),
      name: 'linuxAuto-modelRegistry',
      meta: {
        title: '車型與 CAN 映射',
        isTab: true,
        isDynamic: false,
        menuId: LINUX_AUTO_MENU_IDS.modelRegistry,
        id: LINUX_AUTO_MENU_IDS.modelRegistry
      }
    },
    {
      path: '/linuxAuto-partnerDelivery',
      component: _import('linuxAuto/partnerDelivery/index'),
      name: 'linuxAuto-partnerDelivery',
      meta: {
        title: '合作方交付',
        isTab: true,
        isDynamic: false,
        menuId: LINUX_AUTO_MENU_IDS.partnerDelivery,
        id: LINUX_AUTO_MENU_IDS.partnerDelivery
      }
    },
    {
      path: '/linuxAuto-fleetMonitor',
      component: _import('linuxAuto/fleetMonitor/index'),
      name: 'linuxAuto-fleetMonitor',
      meta: {
        title: '車隊監控',
        isTab: true,
        isDynamic: false,
        menuId: LINUX_AUTO_MENU_IDS.fleetMonitor,
        id: LINUX_AUTO_MENU_IDS.fleetMonitor
      }
    },
    {
      path: '/linuxAuto-dbcEntitlement',
      component: _import('linuxAuto/dbcEntitlement/index'),
      name: 'linuxAuto-dbcEntitlement',
      meta: {
        title: 'DBC 通道開通',
        isTab: true,
        isDynamic: false,
        menuId: LINUX_AUTO_MENU_IDS.dbcEntitlement,
        id: LINUX_AUTO_MENU_IDS.dbcEntitlement
      }
    },
    {
      path: '/linuxAuto-cabinFeatures',
      component: _import('linuxAuto/cabinFeatures/index'),
      name: 'linuxAuto-cabinFeatures',
      meta: {
        title: '座艙能力',
        isTab: true,
        isDynamic: false,
        menuId: LINUX_AUTO_MENU_IDS.cabinFeatures,
        id: LINUX_AUTO_MENU_IDS.cabinFeatures
      }
    },
    {
      path: '/linuxAuto-canAutoMatch',
      component: _import('linuxAuto/canOnboarding/index'),
      name: 'linuxAuto-canAutoMatch',
      meta: {
        title: 'Leo 智能 CAN 接入',
        isTab: true,
        isDynamic: false,
        menuId: LINUX_AUTO_MENU_IDS.canAutoMatch,
        id: LINUX_AUTO_MENU_IDS.canAutoMatch
      }
    },
    {
      path: '/ivi-can-onboarding',
      component: _import('linuxAuto/canOnboarding/index'),
      name: 'iviCanOnboarding',
      meta: {
        title: '車機 CAN 接入',
        isTab: false,
        isDynamic: false,
        iviSurface: true
      }
    },
    {
      path: '/member-hq-dashboard',
      component: _import('hq/member/dashboard'),
      name: 'memberHqDashboard',
      meta: { title: '會員 HQ 總覽', isTab: true, isDynamic: false, menuId: MEMBER_HQ_MENU_IDS.dashboard, id: MEMBER_HQ_MENU_IDS.dashboard }
    },
    {
      path: '/member-hq-detail/:id',
      component: _import('hq/member/detail'),
      name: 'memberHqDetail',
      meta: { title: '會員詳情', isTab: true, isDynamic: false, menuId: MEMBER_HQ_MENU_IDS.detail, id: MEMBER_HQ_MENU_IDS.detail }
    },
    {
      path: '/member-hq-finance',
      component: _import('hq/member/finance'),
      name: 'memberHqFinance',
      meta: { title: '會員財務', isTab: true, isDynamic: false, menuId: MEMBER_HQ_MENU_IDS.finance, id: MEMBER_HQ_MENU_IDS.finance }
    },
    {
      path: '/member-hq-ops',
      component: _import('hq/member/ops'),
      name: 'memberHqOps',
      meta: { title: '會員營運', isTab: true, isDynamic: false, menuId: MEMBER_HQ_MENU_IDS.ops, id: MEMBER_HQ_MENU_IDS.ops }
    },
    {
      path: '/distributor-dashboard',
      component: _import('distributor/dashboard'),
      name: 'distributorDashboard',
      meta: { title: '渠道總覽', isTab: true, isDynamic: false, menuId: MEMBER_HQ_MENU_IDS.distDashboard, id: MEMBER_HQ_MENU_IDS.distDashboard }
    },
    {
      path: '/distributor-members',
      component: _import('distributor/members'),
      name: 'distributorMembers',
      meta: { title: '渠道會員', isTab: true, isDynamic: false, menuId: MEMBER_HQ_MENU_IDS.distMembers, id: MEMBER_HQ_MENU_IDS.distMembers }
    },
    {
      path: '/distributor-profit',
      component: _import('distributor/profit'),
      name: 'distributorProfit',
      meta: { title: '分潤明細', isTab: true, isDynamic: false, menuId: MEMBER_HQ_MENU_IDS.distProfit, id: MEMBER_HQ_MENU_IDS.distProfit }
    },
    {
      path: '/support-ticket-create',
      component: _import('support/ticket/create'),
      name: 'support-ticket-create',
      meta: { title: '提交工单', isTab: true, isDynamic: false, menuId: SUPPORT_TICKET_MENU_IDS.create, id: SUPPORT_TICKET_MENU_IDS.create, supportTicketPermission: 'support:ticket:create' }
    },
    {
      path: '/support-ticket-mine',
      component: _import('support/ticket/mine'),
      name: 'support-ticket-mine',
      meta: { title: '我的工单', isTab: true, isDynamic: false, menuId: SUPPORT_TICKET_MENU_IDS.mine, id: SUPPORT_TICKET_MENU_IDS.mine, supportTicketPermission: 'support:ticket:view:own' }
    },
    {
      path: '/support-ticket-workbench',
      component: _import('support/ticket/workbench'),
      name: 'support-ticket-workbench',
      meta: { title: '售后工作台', isTab: true, isDynamic: false, menuId: SUPPORT_TICKET_MENU_IDS.workbench, id: SUPPORT_TICKET_MENU_IDS.workbench, supportTicketPermission: 'support:ticket:manage' }
    },
    {
      path: '/image-order-produceFivePos',
      component: _import('image/order/produceFivePos'),
      name: 'image-order-produceFivePos',
      meta: {
        title: i18n.t('route.produceFivePos'),
        isTab: true,
        isDynamic: false,
        menuId: PRODUCE_FIVE_POS_MENU_ID,
        id: PRODUCE_FIVE_POS_MENU_ID
      }
    },
    {
      path: '/dataCenter-machineDataStatistics-useStatistics',
      component: _import('dataCenter/machineDataStatistics/useStatistics'),
      name: 'devicesWorkingData',
      meta: {
        title: 'devicesWorkingData',
        isTab: true,
        isDynamic: false
      }
    },
    {
      path: '/dataCenter-machineData-index',
      component: _import('dataCenter/machineData/index'),
      name: 'devicsData',
      meta: {
        title: 'devicsData',
        isTab: true,
        isDynamic: false
      }
    },
    {
      path: '/dataCenter-merchantData-index',
      component: _import('dataCenter/merchantData/index'),
      name: 'merchantsData',
      meta: {
        title: 'merchantsData',
        isTab: true,
        isDynamic: false
      }
    },
    {
      path: '/dataCenter-produceData-index',
      component: _import('dataCenter/produceData/index'),
      name: 'dataCenter-produceData-index',
      meta: {
        title: 'productionData',
        isTab: true,
        isDynamic: false
      }
    },
    {
      path: '/dataCenter-machineDataStatistics-productStatistics',
      component: _import('dataCenter/machineDataStatistics/productStatistics'),
      name: 'coffeeMachineProductionData',
      meta: {
        title: 'coffeeMachineProductionData',
        isTab: true,
        isDynamic: false,
        menuId: DATA_CENTER_COFFEE_MACHINE_MENU_IDS.productionData,
        id: DATA_CENTER_COFFEE_MACHINE_MENU_IDS.productionData
      }
    },
    {
      path: '/dataCenter-machineDataStatistics-singleProductStatistics',
      component: _import('dataCenter/machineDataStatistics/singleProductStatistics'),
      name: 'coffeeMachineSingleCupData',
      meta: {
        title: 'coffeeMachineSingleCupData',
        isTab: true,
        isDynamic: false,
        menuId: DATA_CENTER_COFFEE_MACHINE_MENU_IDS.singleCupData,
        id: DATA_CENTER_COFFEE_MACHINE_MENU_IDS.singleCupData
      }
    },
    {
      path: '/dataCenter-blendProduceDataStatistics-productStatistics',
      component: _import('dataCenter/blendProduceDataStatistics/productStatistics'),
      name: 'dataCenter-blendProduceDataStatistics-productStatistics',
      meta: {
        title: 'beverageOutputData',
        isTab: true,
        isDynamic: false,
        menuId: DATA_CENTER_BLEND_MENU_IDS.productionData,
        id: DATA_CENTER_BLEND_MENU_IDS.productionData
      }
    },
    {
      path: '/dataCenter-blendProduceDataStatistics-singleProductStatistics',
      component: _import('dataCenter/blendProduceDataStatistics/singleProductStatistics'),
      name: 'dataCenter-blendProduceDataStatistics-singleProductStatistics',
      meta: {
        title: 'singleCupData',
        isTab: true,
        isDynamic: false,
        menuId: DATA_CENTER_BLEND_MENU_IDS.singleCupData,
        id: DATA_CENTER_BLEND_MENU_IDS.singleCupData
      }
    },
    {
      path: '/dataCenter-blendProduceDataStatistics-logRecord',
      component: _import('dataCenter/blendProduceDataStatistics/logRecord'),
      name: 'dataCenter-blendProduceDataStatistics-logRecord',
      meta: {
        title: 'faultLog',
        isTab: true,
        isDynamic: false,
        menuId: DATA_CENTER_BLEND_MENU_IDS.faultLog,
        id: DATA_CENTER_BLEND_MENU_IDS.faultLog
      }
    }
  ]
  if (!Array.isArray(routes)) {
    return
  }
  extras.forEach((extra) => {
    if (!extra || !extra.name || !extra.path) {
      return
    }
    const exPath = pathKey(extra.path)
    for (var i = routes.length - 1; i >= 0; i--) {
      const cur = routes[i]
      if (!cur) {
        continue
      }
      if (cur.name === extra.name || pathKey(cur.path) === exPath) {
        routes.splice(i, 1)
      }
    }
    routes.push(extra)
  })
}

function pushDynamicMenuRouteFromItem (menuItem, routes) {
  if (!menuItem || !menuItem.url || !/\S/.test(menuItem.url)) return
  menuItem.url = menuItem.url.replace(/^\//, '')
  const routePathKey = menuItem.url.replace(/\//g, '-')
  // 多设备共用 enName（如 beverageOutputData / productionData / singleCupData）时，
  // 若用 enName 作 route.name，dedupeDynamicRoutesAgainstStatic 会只保留首条 → 配料机等页无法打开。
  const routeName = routePathKey
  var route = {
    path: routePathKey,
    component: null,
    name: routeName,
    meta: {
      menuId: menuItem.id,
      title: menuItem.enName,
      isDynamic: true,
      isTab: true,
      iframeUrl: ''
    }
  }
  if (isURL(menuItem.url)) {
    route['path'] = `i-${menuItem.id}`
    route['name'] = `i-${menuItem.id}`
    route['meta']['iframeUrl'] = menuItem.url
  } else {
    try {
      route['component'] = _import(`${menuItem.url}`) || null
    } catch (e) {}
  }
  routes.push(route)
}

/**
 * 添加动态(菜单)路由
 * @param {*} menuList 菜单列表
 * @param {*} routes 递归创建的动态(菜单)路由
 */
function fnAddDynamicMenuRoutes (menuList = [], routes = []) {
  var temp = []
  for (var i = 0; i < menuList.length; i++) {
    if (menuList[i].menuList != null && menuList[i].menuList.length >= 1) {
      temp = temp.concat(menuList[i].menuList)
    }
    pushDynamicMenuRouteFromItem(menuList[i], routes)
  }
  if (temp.length >= 1) {
    fnAddDynamicMenuRoutes(temp, routes)
  } else {
    appendStaticDeviceConfigRoutes(routes)
    routes = dedupeDynamicRoutesAgainstStatic(routes)
    routes = dedupeRoutesByMenuIdPreferStatic(routes)
    mainRoutes.name = 'main'
    const mergedChildren = dedupeMainChildrenFirstWins(STATIC_MAIN_CHILDREN_SNAPSHOT.concat(routes))
    mainRoutes.children = mergedChildren
    const mainForMatcher = {
      path: '/',
      component: mainRoutes.component,
      name: 'main',
      redirect: mainRoutes.redirect,
      meta: mainRoutes.meta,
      children: mergedChildren,
      beforeEnter: mainRoutes.beforeEnter
    }
    replaceRouterMatcher(
      globalRoutes.concat([
        mainForMatcher,
        { path: '*', redirect: { name: '404' } }
      ])
    )
    sessionStorage.setItem('dynamicMenuRoutes', JSON.stringify(mainRoutes.children || '[]'))
  }
}

/**
 * menuApi／permission 非 401 失敗時，仍要能用靜態 main 子路由 + 空動態菜單進入首頁
 *（避免從 /dataShow 點「进入平台」時一直 next(false)）
 */
function applyEmptyDynamicMenuFallback () {
  if (router.options.isAddDynamicMenuRoutes) return
  try {
    fnAddDynamicMenuRoutes([])
  } catch (e) {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.warn('[router] applyEmptyDynamicMenuFallback', e)
    }
  }
  router.options.isAddDynamicMenuRoutes = true
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js